import {
    pinyin
} from "pinyin-pro"
const toC_C6 = function (Blockly) {
    Blockly.Names.prototype.safeName_ = function (name) {
        if (!name) {
            name = 'unnamed';
        } else {
            //   name = encodeURI(name.replace(/ /g, '_')).replace(/[^\w]/g, '_');

            name = pinyin(name, {
                toneType: "none", //是否带音标
                type: "array", //返回格式
                nonZh: 'consecutive' //非汉字拼接方式
            }).join("_")
            name = name.replace(/[^\w]/g, '_').replace(/_+/g, '_');

            if ('0123456789'.indexOf(name[0]) != -1) {
                name = 'my_' + name;
            }
        }
        return name;
    };



    Blockly.C = new Blockly.Generator("C");
    Blockly.C.addReservedWords("False,None,True,and,as,assert,break,class,continue,def,del,elif,else,except,exec,finally,for,from,global,if,import,in,is,lambda,nonlocal,not,or,pass,print,raise,return,try,while,with,yield,NotImplemented,Ellipsis,__debug__,quit,exit,copyright,license,credits,ArithmeticError,AssertionError,AttributeError,BaseException,BlockingIOError,BrokenPipeError,BufferError,BytesWarning,ChildProcessError,ConnectionAbortedError,ConnectionError,ConnectionRefusedError,ConnectionResetError,DeprecationWarning,EOFError,Ellipsis,EnvironmentError,Exception,FileExistsError,FileNotFoundError,FloatingPointError,FutureWarning,GeneratorExit,IOError,ImportError,ImportWarning,IndentationError,IndexError,InterruptedError,IsADirectoryError,KeyError,KeyboardInterrupt,LookupError,MemoryError,ModuleNotFoundError,NameError,NotADirectoryError,NotImplemented,NotImplementedError,OSError,OverflowError,PendingDeprecationWarning,PermissionError,ProcessLookupError,RecursionError,ReferenceError,ResourceWarning,RuntimeError,RuntimeWarning,StandardError,StopAsyncIteration,StopIteration,SyntaxError,SyntaxWarning,SystemError,SystemExit,TabError,TimeoutError,TypeError,UnboundLocalError,UnicodeDecodeError,UnicodeEncodeError,UnicodeError,UnicodeTranslateError,UnicodeWarning,UserWarning,ValueError,Warning,ZeroDivisionError,_,__build_class__,__debug__,__doc__,__import__,__loader__,__name__,__package__,__spec__,abs,all,any,apply,ascii,basestring,bin,bool,buffer,bytearray,bytes,callable,chr,classmethod,cmp,coerce,compile,complex,copyright,credits,delattr,dict,dir,divmod,enumerate,eval,exec,execfile,exit,file,filter,float,format,frozenset,getattr,globals,hasattr,hash,help,hex,id,input,int,intern,isinstance,issubclass,iter,len,license,list,locals,long,map,max,memoryview,min,next,object,oct,open,ord,pow,print,property,quit,range,raw_input,reduce,reload,repr,reversed,round,set,setattr,slice,sorted,staticmethod,str,sum,super,tuple,type,unichr,unicode,vars,xrange,zip");
    Blockly.C.ORDER_ATOMIC = 0;
    Blockly.C.ORDER_COLLECTION = 1;
    Blockly.C.ORDER_STRING_CONVERSION = 1;
    Blockly.C.ORDER_MEMBER = 2.1;
    Blockly.C.ORDER_FUNCTION_CALL = 2.2;
    Blockly.C.ORDER_EXPONENTIATION = 3;
    Blockly.C.ORDER_UNARY_SIGN = 4;
    Blockly.C.ORDER_BITWISE_NOT = 4;
    Blockly.C.ORDER_MULTIPLICATIVE = 5;
    Blockly.C.ORDER_ADDITIVE = 6;
    Blockly.C.ORDER_BITWISE_SHIFT = 7;
    Blockly.C.ORDER_BITWISE_AND = 8;
    Blockly.C.ORDER_BITWISE_XOR = 9;
    Blockly.C.ORDER_BITWISE_OR = 10;
    Blockly.C.ORDER_RELATIONAL = 11;
    Blockly.C.ORDER_LOGICAL_AND = 13;
    Blockly.C.ORDER_LOGICAL_OR = 14;
    Blockly.C.ORDER_CONDITIONAL = 15;
    Blockly.C.ORDER_LAMBDA = 16;
    Blockly.C.ORDER_NONE = 99;
    Blockly.C.ORDER_OVERRIDES = [
        [Blockly.C.ORDER_FUNCTION_CALL, Blockly.C.ORDER_MEMBER],
        [Blockly.C.ORDER_FUNCTION_CALL, Blockly.C.ORDER_FUNCTION_CALL],
        [Blockly.C.ORDER_MEMBER, Blockly.C.ORDER_MEMBER],
        [Blockly.C.ORDER_MEMBER, Blockly.C.ORDER_FUNCTION_CALL],
        [Blockly.C.ORDER_LOGICAL_AND, Blockly.C.ORDER_LOGICAL_AND],
        [Blockly.C.ORDER_LOGICAL_OR, Blockly.C.ORDER_LOGICAL_OR],
        [1, 2]
    ];

    

    Blockly.Variables.allUsedVariabless = function (a) {
        if (a instanceof Blockly.Block) var b = a.getDescendants(!1);
        else if (a instanceof Blockly.Workspace || a instanceof Blockly.WorkspaceSvg) b = a.getAllBlocks();
        else throw new Error("Not Block or Workspace: " + a);
        var c = Blockly.Variables.noVariableText();
        a = Object.create(null);
        for (var d = 0; d < b.length; d++) {
            var e = b[d].getVarModels();
            if (e)
                for (var f = 0; f < e.length; f++) {
                    var g = e[f];
                    // g.getId() && g.name.toLowerCase() != c && (a[g.name.toLowerCase()] = g.name)
                    if (g.getId() && g.name.toLowerCase() !== c) {
                        if (g.type === "") {
                            if (!a['']) {
                                a[''] = {}
                            }
                            a[''][g.name.toLowerCase()] = g.name
                        } else if (g.type === "list") {
                            if (!a['list']) {
                                a['list'] = {}
                            }
                            a['list'][g.name.toLowerCase()] = g.name
                        } else {

                        }
                    }
                }
        }
        let obj = {}
        for (let i in a) {
            let b = []
            for (let j in a[i]) {
                b.push(a[i][j])
            }
            obj[i] = b
        }

        // b = [];
        // for (var h in a) b.push(a[h]);
        return obj
    };
    Blockly.C.init = function (a) {


        this.INDENT = "    " //开头空4个空格


        Blockly.C.PASS = this.INDENT + "pass\n";
        Blockly.C.definitions_ = Object.create(null);
        Blockly.C.functionNames_ = Object.create(null);
        Blockly.C.define = Object.create(null);
        Blockly.C.include = Object.create(null);
        Blockly.C.list = Object.create(null);
        Blockly.C.IotConfig = Object.create(null);
        Blockly.C.FnList = Object.create(null);
        // Blockly.C.varibles = new Array();
        Blockly.C.variableDB_ ? Blockly.C.variableDB_.reset() : Blockly.C.variableDB_ = new Blockly.Names(Blockly.C.RESERVED_WORDS_);
        Blockly.C.variableDB_.setVariableMap(a.getVariableMap());
        for (var b = [], c = Blockly.Variables.allDeveloperVariables(a), d = 0; d < c.length; d++) b.push(Blockly.C.variableDB_.getName(c[d],
            Blockly.Names.DEVELOPER_VARIABLE_TYPE) + " = None");
        // a = Blockly.Variables.allUsedVarModels(a);
        a = Blockly.Variables.allUsedVariabless(a)
        for (let i in a) {
            for (let j in a[i]) {
                let varname = a[i][j]

                varname = Blockly.C.variableDB_.getName(varname, Blockly.VARIABLE_CATEGORY_NAME)
                varname = Blockly.Names.prototype.safeName_(varname, Blockly.VARIABLE_CATEGORY_NAME)
                if (i == '') {
                    b.push("volatile double " + Blockly.C.variablesHead + varname + " = 0;")
                } else {
                    Blockly.C.include.include_list = '#include <jmdlist.h>';
                    b.push("List " + Blockly.C.data_listHead + varname + ` = {
    {0},
    List_Append,
    List_Display,
    List_Insert,
    List_Replace,
    List_Change,
    List_Delete_One,
    List_Delete_All,
    List_Find_Num,
    List_Find_Data,
    List_Find_Node,
    List_Include_Data
};`)
                }
            }
        };
        Blockly.C.definitions_.variables = b.join("\n")
    };
    Blockly.C.finish = function (a) {
        var b = [],
            c = [],
            d = [],
            e = [],
            f,
            l = '',
            fnList = []
        for (f in Blockly.C.definitions_) {
            var h = Blockly.C.definitions_[f];
            h.match(/^(from\s+\S+\s+)?import\s+\S+/) ? b.push(h) : c.push(h)
        }

        //遍历列表的所有参数
        for (let i in Blockly.C.list) {
            l += i + '=[]\n'
        }

        for (var g in Blockly.C.define) d.push(Blockly.C.define[g]);
        for (g in Blockly.C.include) e.push(Blockly.C.include[g]);
        for (let item in Blockly.C.FnList) fnList.push(Blockly.C.FnList[item]);


        delete Blockly.C.definitions_;
        delete Blockly.C.functionNames_;
        delete Blockly.C.FnList;

        Blockly.C.variableDB_.reset();
        return (d.join("\n") + "\n" + e.join("\n") + "\n" + b.join("\n") + "\n" + l + "\n\n" + c.join("\n\n")).replace(/\n\n+/g, "\n\n").replace(/\n*$/,
            "\n\n") + fnList.join('\r\n') + "\n\n" + a
    };
    Blockly.C.scrubNakedValue = function (a) {
        return a + "\n"
    };
    Blockly.C.quote_ = function (a) {
        a = a.replace(/\\/g, "\\\\").replace(/\n/g, "\\\n");
        var b = '"'; - 1 !== a.indexOf('"') && (-1 === a.indexOf("'") ? b = "'" : a = a.replace(/'/g, '\\"'));
        return b + a + b
    };
    Blockly.C.multiline_quote_ = function (a) {
        a = a.replace(/'''/g, "\\'\\'\\'");
        return "'''" + a + "'''"
    };
    Blockly.C.scrub_ = function (a, b, c) {
        var d = "";
        if (!a.outputConnection || !a.outputConnection.targetConnection) {
            var e = a.getCommentText();
            // e && (e = Blockly.utils.string.wrap(e, Blockly.C.COMMENT_WRAP - 3), d += Blockly.C.prefixLines(e + "\n", "// "));
            for (var f = 0; f < a.inputList.length; f++) a.inputList[f].type == Blockly.INPUT_VALUE && (e = a.inputList[f].connection.targetBlock()) && (e = Blockly.C.allNestedComments(e)) && (d += Blockly.C.prefixLines(e, "// "))
        }
        a = a.nextConnection && a.nextConnection.targetBlock();
        c = c ? "" : Blockly.C.blockToCode(a);
        return d + b + c
    };
    Blockly.C.getAdjustedInt = function (a, b, c, d) {
        c = c || 0;
        a.workspace.options.oneBasedIndex && c--;
        var e = a.workspace.options.oneBasedIndex ? "1" : "0";
        a = Blockly.C.valueToCode(a, b, c ? Blockly.C.ORDER_ADDITIVE : Blockly.C.ORDER_NONE) || e;
        Blockly.isNumber(a) ? (a = parseInt(a, 10) + c, d && (a = -a)) : (a = 0 < c ? "int(" + a + " + " + c + ")" : 0 > c ? "int(" + a + " - " + -c + ")" : "int(" + a + ")", d && (a = "-" + a));
        return a
    };
    Blockly.C.transformColor = function (color) {
        var colors = color.slice(1)
        var newColors = ''
        for (var j = 0; j < colors.length; j++) {
            if (colors[j] !== '0') {
                newColors = colors.slice(j)
                break;
            } else if (colors == '000000') {
                newColors = '0'
                break;
            }
        }
        var newColor = '';
        for (var i = 0; i < newColors.length; i++) {
            newColor += newColors[i].toLocaleUpperCase()
        }
        return '0x' + newColor

    }

    Blockly.C.matrixToString16 = function (matrix) {
        let arr = []
        for (var i = 0; i < matrix.length;) {
            // 字符串翻转
            var length = (matrix.slice(i, i + 8)).length;
            length = length - 1;
            var newstr = ''
            for (var x = length; x >= 0; x--) {
                newstr += (matrix.slice(i, i + 8)).charAt(x);
            }

            arr.push(newstr)
            i += 8
        }
        let value = ''
        for (var j = 0; j < arr.length; j++) {
            let temp = parseInt(arr[j], 2)
            temp = temp.toString(16)
            // 十六进制，不够两位补0
            let zero = '00';
            let tmp = 2 - temp.length;
            value += zero.substr(0, tmp) + temp;

        }
        return value
    }

    /**
     * 去掉列表积木中带 （*，）
     * @param {*} block 
     * @param {*} name 
     * @param {*} value 
     * @returns 
     */
    Blockly.C.removeStar = (block, name, value) => {
        if (
            block.getInputTargetBlock(name) &&
            block.getInputTargetBlock(name).type == "data_itemoflist"
        ) {
            value = value.replace(/^\(\*/ig, "").replace(/\)$/ig, "")
            return value
        }
        return value
    }



    Blockly.C.pass = "      pass\n";

    Blockly.C.jmd_start = function (a) {
        let task = a.getFieldValue("TASK")
        // Blockly.C.jmdstart[a.id] = task
        let num = task.slice(4, 5)
        Blockly.C.define[task] = `#define _TASK_${num}_ 1`;
        Blockly.C.include.JMLIB = '#include "JMLib.c"';
        Blockly.C.FnList[task] = `void ${task}(void);`
        return `void ${task}(void)\r\n{\n`
    };

    Blockly.C.jmd_start_C1 = function (a) {
        let task = a.getFieldValue("TASK")
        // Blockly.C.jmdstart[a.id] = task
        let num = task.slice(4, 5)
        Blockly.C.define[task] = `#define _TASK_${num}_ 1`;
        Blockly.C.include.JMLIB = '#include "JMLib.c"';
        Blockly.C.FnList[task] = `void ${task}(void);`
        return `void ${task}(void)\r\n{\n`
    };

    Blockly.C.jmd_getLeftButton = function (a) {
        Blockly.C.include.GetLeftButton = '#include <GetLeftButton.h>';
        return ['GetLeftButton()', 1]
    };
    Blockly.C.jmd_getRightButton = function (a) {
        Blockly.C.include.GetRightButton = '#include <GetRightButton.h>';
        return ['GetRightButton()', 1]
    };
    Blockly.C.jmd_getInMic = function (a) {
        Blockly.C.include.GetInMic = '#include <GetInMic.h>';
        return ['GetInMic()', 1]
    };
    Blockly.C.jmd_getBatteryVoltage = function (a) {
        Blockly.C.include.GetInVotage = '#include <GetInVotage.h>';
        return ['GetInVotage()', 1]
    };
    Blockly.C.jmd_getControlTime = function (a) {
        Blockly.C.include.GetSysTime = '#include <GetSysTime.h>';
        return ['GetSysTime()', 1]
    };
    Blockly.C.jmd_setControlTimeZero = function (a) {
        Blockly.C.include.SetSysTime = '#include <SetSysTime.h>';
        return '    SetSysTime();\r\n';
    };
    Blockly.C.jmd_setBeep = function (a) {
        Blockly.C.include.SetInBeep = '#include <SetInBeep.h>';
        let state = a.getFieldValue('STATE')
        return '    SetInBeep(' + state + ');\r\n'
    };
    Blockly.C.jmd_setInSound = function (a) {
        Blockly.C.include.SetInSound = '#include <SetInSound.h>';
        let address = a.getFieldValue('FREQUENCY')
        let time = Blockly.C.valueToCode(a, "TIME", 2);
        return '    SetInSound(' + address + ',(' + time + ' * 1000));\r\n'
    };
    Blockly.C.jmd_getData = function (a) {
        Blockly.C.include.GetData = '#include <GetData.h>';
        return ["GetData(" + Blockly.C.valueToCode(a, "ADDRESS", 2) + ")", 1]
    };
    Blockly.C.jmd_setData = function (a) {
        Blockly.C.include.SetData = '#include <SetData.h>';
        let address = Blockly.C.valueToCode(a, "ADDRESS", 2)
        let value = Blockly.C.valueToCode(a, "VALUE", 2)
        return '    SetData(' + address + ',' + value + ");\r\n"
    };
    Blockly.C.jmd_setUartData = function (a) {
        Blockly.C.include.SetUartData = '#include <SetUartData.h>';
        let data = Blockly.C.valueToCode(a, "DATA", 2)
        let baudRate = a.getFieldValue('BAUDRATE')
        return '    SetUartData(' + data + ',' + baudRate + ");\r\n"
    };
    Blockly.C.jmd_getUartData = function (a) {
        Blockly.C.include.GetUartData = '#include <GetUartData.h>';
        let baudRate = a.getFieldValue('BAUDRATE')
        return ['GetUartData(' + baudRate + ")", 1]
    };
    Blockly.C.jmd_setMp3Sound = function (a) {
        Blockly.C.include.SetMp3Sound = '#include <SetMp3Sound.h>';
        let volume = Blockly.C.valueToCode(a, "VOLUME", 2)
        return '    SetMp3Sound(' + volume + ");\r\n"
    };


    // C1 RCU 特有的控制器积木块

    Blockly.C.jmd_releaseButton = function (a) {
        Blockly.C.include.Releasebutton = '#include <Releasebutton.h>';
        let state = a.getFieldValue("STATE")
        return '    Releasebutton(' + state + ");\r\n"
    };

    Blockly.C.jmd_setRGB = function (a) {
        Blockly.C.include.SetRGB = '#include <SetRGB.h>';

        let color1 = Blockly.C.valueToCode(a, "COLOR1", 2)
        color1 = Blockly.C.transformColor(color1)

        let color2 = Blockly.C.valueToCode(a, "COLOR2", 2)
        color2 = Blockly.C.transformColor(color2)

        let color3 = Blockly.C.valueToCode(a, "COLOR3", 2)
        color3 = Blockly.C.transformColor(color3)

        let color4 = Blockly.C.valueToCode(a, "COLOR4", 2)
        color4 = Blockly.C.transformColor(color4)

        let color5 = Blockly.C.valueToCode(a, "COLOR5", 2)
        color5 = Blockly.C.transformColor(color5)

        return '    SetRGB(' + color1 + "," + color2 + "," + color3 + "," + color4 + "," + color5 + ");\r\n"
    };

    Blockly.C.jmd_setMusic = function (a) {
        Blockly.C.include.SetMusic = '#include <SetMusic.h>';
        return '    SetMusic();\r\n'
    };

    Blockly.C.jmd_set3CLed = function (a) {
        Blockly.C.include.Set3CLed = '#include <Set3CLed.h>';
        let arg1 = a.getFieldValue("LAMP")
        let arg2 = a.getFieldValue("COLOR")
        return '    Set3CLed(' + arg1 + "," + arg2 + ");\r\n"
    };




    //马达

    Blockly.C.motor_setMotor = function (a) {
        Blockly.C.include.SetMotor = '#include <SetMotor.h>';
        let motorport = a.getFieldValue('MOTORPORT')
        let value = Blockly.C.valueToCode(a, "VALUE", 2)
        return '    SetMotor(' + motorport + ',' + value + ");\r\n"
    };
    Blockly.C.motor_getMotorCode = function (a) {
        Blockly.C.include.GetMotorCode = '#include <GetMotorCode.h>';
        let motorport = a.getFieldValue('MOTORPORT')
        return ['GetMotorCode(' + motorport + ")", 1]
    };
    Blockly.C.motor_setMotorCode = function (a) {
        Blockly.C.include.SetMotorCode = '#include <SetMotorCode.h>';
        let motorport = a.getFieldValue('MOTORPORT')
        return '    SetMotorCode(' + motorport + ");\r\n"
    };
    Blockly.C.motor_setServoMotor = function (a) {
        Blockly.C.include.SetMotorServo = '#include <SetMotorServo.h>';
        let motorport = a.getFieldValue('PORT')
        let speed = Blockly.C.valueToCode(a, "SPEED", 2)
        let angle = Blockly.C.valueToCode(a, "ANGLE", 2)
        return '    SetMotorServo(' + motorport + "," + speed + "," + angle + ");\r\n"
    };
    Blockly.C.motor_waitServomotor = function (a) {
        Blockly.C.include.SetWaitForAngle = '#include <SetWaitForAngle.h>';
        let motorport = a.getFieldValue('PORT')
        let speed = Blockly.C.valueToCode(a, "SPEED", 2)
        let angle = Blockly.C.valueToCode(a, "ANGLE", 2)
        return '    SetWaitForAngle(' + motorport + "," + speed + "," + angle + ");\r\n"
    };
    Blockly.C.motor_setLinearSpeed = function (a) {
        Blockly.C.include.SetMotorStraightAngle = '#include <SetMotorStraightAngle.h>';
        let motorport1 = a.getFieldValue('PORT1')
        let motorport2 = a.getFieldValue('PORT2')
        let speed = Blockly.C.valueToCode(a, "SPEED", 2)
        let pulse = Blockly.C.valueToCode(a, "PULSE", 2)
        return '    SetMotorStraightAngle(' + motorport1 + "," + motorport2 + "," + speed + "," + pulse + ");\r\n"
    };
    Blockly.C.motor_setTurnSpeed = function (a) {
        Blockly.C.include.SetCarTurn = '#include <SetCarTurn.h>';
        let motorport1 = a.getFieldValue('PORT1')
        let motorport2 = a.getFieldValue('PORT2')
        let speed = Blockly.C.valueToCode(a, "SPEED", 2)
        let pulse = Blockly.C.valueToCode(a, "PULSE", 2)
        return '    SetCarTurn(' + motorport1 + "," + motorport2 + "," + speed + "," + pulse + ");\r\n"
    };
    Blockly.C.motor_setMotorPower = function (a) {
        Blockly.C.include.SetMotorPower = '#include <SetMotorPower.h>';
        let motorone = Blockly.C.valueToCode(a, "MOTORONE", 2)
        let motortwo = Blockly.C.valueToCode(a, "MOTORTWO", 2)
        let motorthree = Blockly.C.valueToCode(a, "MOTORTHREE", 2)
        let motorfour = Blockly.C.valueToCode(a, "MOTORFOUR", 2)
        return '    SetMotorPower(' + motorone + "," + motortwo + "," + motorthree + "," + motorfour + ");\r\n"
    };
    Blockly.C.motor_setMotorStraight = function (a) {
        Blockly.C.include.SetMotorStraight = '#include <SetMotorStraight.h>';
        let motorport1 = a.getFieldValue('MOTORPORTONE')
        let motorport2 = a.getFieldValue('MOTORPORTTWO')
        let speed = Blockly.C.valueToCode(a, "SPEED", 2)
        return '    SetMotorStraight(' + motorport1 + "," + motorport2 + "," + speed + ");\r\n"
    };
    Blockly.C.motor_setMotorStraightTurn = function (a) {
        Blockly.C.include.SetMotorStraightTurn = '#include <SetMotorStraightTurn.h>';
        let motorport1 = a.getFieldValue('MOTORPORTONE')
        let motorport2 = a.getFieldValue('MOTORPORTTWO')
        let speed = Blockly.C.valueToCode(a, "SPEED", 2)
        let angle = Blockly.C.valueToCode(a, "ANGLE", 2)
        return '    SetMotorStraightTurn(' + motorport1 + "," + motorport2 + "," + speed + "," + angle + ");\r\n"
    };
    Blockly.C.motor_setServo = function (a) {
        Blockly.C.include.SetServo = '#include <SetServo.h>';
        let prop = a.getFieldValue('PROP')
        let angle = Blockly.C.valueToCode(a, "ANGLE", 2)
        return '    SetServo(' + prop + "," + angle + ");\r\n"
    };
    Blockly.C.motor_setServoTime = function (a) {
        Blockly.C.include.SetServoTime = '#include <SetServoTime.h>';
        let prop = a.getFieldValue('PROP')
        let angle = Blockly.C.valueToCode(a, "ANGLE", 2)
        let time = Blockly.C.valueToCode(a, "TIME", 2)
        return '    SetServoTime(' + prop + "," + angle + "," + time + ");\r\n"
    };
    Blockly.C.motor_setServo_E6 = function (a) {
        Blockly.C.include.SetServo = '#include <SetServo.h>';
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 2);
        return "    SetServo(" + prop + "," + angle + ");\r\n";
    };
    Blockly.C.motor_setServoTime_E6 = function (a) {
        Blockly.C.include.SetServoTime = '#include <SetServoTime.h>';
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 2);
        let time = Blockly.C.valueToCode(a, "TIME", 2);
        return "    SetServoTime(" + prop + "," + angle + "," + time + ");\r\n";
    };
    Blockly.C.motor_setOneServo = function (a, b, c) {
        Blockly.C.include.SetServoTime = '#include <SetOneServo.h>';
        let prop = a.getFieldValue("PORT");
        let channel = Blockly.C.valueToCode(a, "CHANNEL", 2);
        let angle = Blockly.C.valueToCode(a, "ANGLE", 2);
        let time = Blockly.C.valueToCode(a, "TIME", 2);
        return "    SetOneServo(" + prop + "," + channel + "," + angle + "," + time + ");\r\n";
    };
    Blockly.C.E6_motor_setMagneticServoDegreeTime = function (a, b, c) {
        Blockly.C.include.SetMagneticServoDegreeTime = '#include <SetMagneticServoDegreeTime.h>';
        let port = a.getFieldValue("PORT");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 16);
        let time = Blockly.C.valueToCode(a, "TIME", 16);
        return `    SetMagneticServoDegreeTime(${port},${angle},${time});\r\n`;
    };
    Blockly.C.E6_motor_setMagneticServoDegreeSpeed = function (a, b, c) {
        Blockly.C.include.SetMagneticServoDegreeSpeed = '#include <SetMagneticServoDegreeSpeed.h>';
        let port = a.getFieldValue("PORT");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 16);
        let speed = Blockly.C.valueToCode(a, "SPEED", 16);
        return `    SetMagneticServoDegreeSpeed(${port},${angle},${speed});\r\n`;
    };
    Blockly.C.E6_motor_setMagneticServoCodeMotor = function (a, b, c) {
        Blockly.C.include.SetMagneticServoCodeMotor = '#include <SetMagneticServoCodeMotor.h>';
        let port = a.getFieldValue("PORT");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 16);
        let speed = Blockly.C.valueToCode(a, "SPEED", 16);
        return `    SetMagneticServoCodeMotor(${port},${angle},${speed});\r\n`;
    };

    Blockly.C.E3_motor_setMagneticServoDegreeTime = function (a, b, c) {
        Blockly.C.include.SetMagneticServoDegreeTime = '#include <SetMagneticServoDegreeTime.h>';
        let port = a.getFieldValue("PORT");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 16);
        let time = Blockly.C.valueToCode(a, "TIME", 16);
        return `    SetMagneticServoDegreeTime(${port},${angle},${time});\r\n`;
    };
    Blockly.C.E3_motor_setMagneticServoDegreeSpeed = function (a, b, c) {
        Blockly.C.include.SetMagneticServoDegreeSpeed = '#include <SetMagneticServoDegreeSpeed.h>';
        let port = a.getFieldValue("PORT");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 16);
        let speed = Blockly.C.valueToCode(a, "SPEED", 16);
        return `    SetMagneticServoDegreeSpeed(${port},${angle},${speed});\r\n`;
    };
    Blockly.C.E3_motor_setMagneticServoCodeMotor = function (a, b, c) {
        Blockly.C.include.SetMagneticServoCodeMotor = '#include <SetMagneticServoCodeMotor.h>';
        let port = a.getFieldValue("PORT");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 16);
        let speed = Blockly.C.valueToCode(a, "SPEED", 16);
        return `    SetMagneticServoCodeMotor(${port},${angle},${speed});\r\n`;
    };
    Blockly.C.M6_motor_setMagneticServoDegreeTime = function (a, b, c) {
        Blockly.C.include.SetMagneticServoDegreeTime = '#include <SetMagneticServoDegreeTime.h>';
        let port = a.getFieldValue("PORT");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 16);
        let time = Blockly.C.valueToCode(a, "TIME", 16);
        return `    SetMagneticServoDegreeTime(${port},${angle},${time});\r\n`;
    };
    Blockly.C.M6_motor_setMagneticServoDegreeSpeed = function (a, b, c) {
        Blockly.C.include.SetMagneticServoDegreeSpeed = '#include <SetMagneticServoDegreeSpeed.h>';
        let port = a.getFieldValue("PORT");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 16);
        let speed = Blockly.C.valueToCode(a, "SPEED", 16);
        return `    SetMagneticServoDegreeSpeed(${port},${angle},${speed});\r\n`;
    };
    Blockly.C.M6_motor_setMagneticServoCodeMotor = function (a, b, c) {
        Blockly.C.include.SetMagneticServoCodeMotor = '#include <SetMagneticServoCodeMotor.h>';
        let port = a.getFieldValue("PORT");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 16);
        let speed = Blockly.C.valueToCode(a, "SPEED", 16);
        return `    SetMagneticServoCodeMotor(${port},${angle},${speed});\r\n`;
    };

    // C1 RCU 特有的马达积木块

    Blockly.C.motor_setMotor_C1 = function (a) {
        Blockly.C.include.SetMotor = '#include <SetMotor.h>';
        let prop = a.getFieldValue("MOTORPORT");
        let value = Blockly.C.valueToCode(a, "VALUE", 2);
        return "    SetMotor(" + prop + "," + value + ");\r\n";
    };
    Blockly.C.motor_setServoMotor_C1 = function (a) {
        Blockly.C.include.SetMotorServo = '#include <SetMotorServo.h>';
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 2);
        return "    SetMotorServo(" + prop + "," + angle + ");\r\n";
    };
    Blockly.C.motor_setMotorPower_C1 = function (a) {
        Blockly.C.include.SetMotorPower = '#include <SetMotorPower.h>';
        let arg1 = Blockly.C.valueToCode(a, "MOTORONE", 2);
        let arg2 = Blockly.C.valueToCode(a, "MOTORTWO", 2);
        return "    SetMotorPower(" + arg1 + "," + arg2 + ");\r\n";
    };


    // E3 RCU 特有的马达积木块

    Blockly.C.motor_setServo_E3 = function (a) {
        Blockly.C.include.SetServo = '#include <SetServo.h>';
        let arg1 = a.getFieldValue("PORT")
        let arg2 = Blockly.C.valueToCode(a, "ANGLE", 2);
        return "    SetServo(" + arg1 + "," + arg2 + ");\r\n";
    };
    Blockly.C.motor_setServoTime_E3 = function (a) {
        Blockly.C.include.SetServoTime = '#include <SetServoTime.h>';
        let arg1 = a.getFieldValue("PORT")
        let arg2 = Blockly.C.valueToCode(a, "ANGLE", 2);
        let arg3 = Blockly.C.valueToCode(a, "TIME", 2);
        return "    SetServoTime(" + arg1 + "," + arg2 + "," + arg3 + ");\r\n";
    };

    // M6 RCU 特有的马达积木块

    Blockly.C.motor_setServoMotor48 = function (a) {
        Blockly.C.include.SetMotorServo = '#include <SetMotorServo.h>';
        let arg1 = a.getFieldValue("PORT")
        let arg2 = Blockly.C.valueToCode(a, "SPEED", 2);
        let arg3 = Blockly.C.valueToCode(a, "ANGLE", 2);
        return "    SetMotorServo(" + arg1 + "," + arg2 + "," + arg3 + ");\r\n";
    };
    Blockly.C.motor_waitServomotor48 = function (a) {
        Blockly.C.include.SetWaitForAngle = '#include <SetWaitForAngle.h>';
        let arg1 = a.getFieldValue("PORT")
        let arg2 = Blockly.C.valueToCode(a, "SPEED", 2);
        let arg3 = Blockly.C.valueToCode(a, "ANGLE", 2);
        return "    SetWaitForAngle(" + arg1 + "," + arg2 + "," + arg3 + ");\r\n";
    };
    Blockly.C.motor_setServoMotor128 = function (a) {
        Blockly.C.include.SetMotorServo128 = '#include <SetMotorServo128.h>';
        let arg1 = a.getFieldValue("PORT")
        let arg2 = Blockly.C.valueToCode(a, "SPEED", 2);
        let arg3 = Blockly.C.valueToCode(a, "ANGLE", 2);
        return "    SetMotorServo128(" + arg1 + "," + arg2 + "," + arg3 + ");\r\n";
    };
    Blockly.C.motor_waitservomotor128 = function (a) {
        Blockly.C.include.SetWaitForAngle128 = '#include <SetWaitForAngle128.h>';
        let arg1 = a.getFieldValue("PORT")
        let arg2 = Blockly.C.valueToCode(a, "SPEED", 2);
        let arg3 = Blockly.C.valueToCode(a, "ANGLE", 2);
        return "    SetWaitForAngle128(" + arg1 + "," + arg2 + "," + arg3 + ");\r\n";
    };
    
    Blockly.C.M6_motor_setServoMotor = function (a) {
        Blockly.C.include.SetMotorServo128 = '#include <SetMotorServo.h>';
        let arg1 = a.getFieldValue("PORT")
        let arg2 = Blockly.C.valueToCode(a, "SPEED", 2);
        let arg3 = Blockly.C.valueToCode(a, "ANGLE", 2);
        return "    SetMotorServo(" + arg1 + "," + arg2 + "," + arg3 + ");\r\n";
    };
    Blockly.C.M6_motor_waitservomotor = function (a) {
        Blockly.C.include.SetWaitForAngle128 = '#include <SetWaitForAngle.h>';
        let arg1 = a.getFieldValue("PORT")
        let arg2 = Blockly.C.valueToCode(a, "SPEED", 2);
        let arg3 = Blockly.C.valueToCode(a, "ANGLE", 2);
        return "    SetWaitForAngle(" + arg1 + "," + arg2 + "," + arg3 + ");\r\n";
    };
    Blockly.C.motor_setServo_M6 = function (a) {
        Blockly.C.include.SetServo = '#include <SetServo.h>';
        let arg1 = a.getFieldValue("PORT")
        let arg2 = Blockly.C.valueToCode(a, "ANGLE", 2);
        return "    SetServo(" + arg1 + "," + arg2 + ");\r\n";
    };
    Blockly.C.motor_setServoTime_M6 = function (a) {
        Blockly.C.include.SetServoTime = '#include <SetServoTime.h>';
        let arg1 = a.getFieldValue("PORT")
        let arg2 = Blockly.C.valueToCode(a, "ANGLE", 2);
        let arg3 = Blockly.C.valueToCode(a, "TIME", 2);
        return "    SetServoTime(" + arg1 + "," + arg2 + "," + arg3 + ");\r\n";
    };

    Blockly.C.E6_motor_setSeeringEngine = function (a) {
        Blockly.C.include.SetSeeringEngine = '#include <SetSeeringEngine.h>';
        let arg1 = a.getFieldValue("PORT")
        let arg2 = Blockly.C.valueToCode(a, "ANGLE", 2);
        return "    SetSeeringEngine(" + arg1 + "," + arg2 + ");\r\n";
    };
    Blockly.C.E3_motor_setSeeringEngine = function (a) {
        Blockly.C.include.SetSeeringEngine = '#include <SetSeeringEngine.h>';
        let arg1 = a.getFieldValue("PORT")
        let arg2 = Blockly.C.valueToCode(a, "ANGLE", 2);
        return "    SetSeeringEngine(" + arg1 + "," + arg2 + ");\r\n";
    };
    Blockly.C.M6_motor_setSeeringEngine = function (a) {
        Blockly.C.include.SetSeeringEngine = '#include <SetSeeringEngine.h>';
        let arg1 = a.getFieldValue("PORT")
        let arg2 = Blockly.C.valueToCode(a, "ANGLE", 2);
        return "    SetSeeringEngine(" + arg1 + "," + arg2 + ");\r\n";
    };
    Blockly.C.E6_motor_setSeeringEngineTime = function (a) {
        Blockly.C.include.SetSeeringEngineTime = '#include <SetSeeringEngineTime.h>';
        let arg1 = a.getFieldValue("PORT")
        let arg2 = Blockly.C.valueToCode(a, "ANGLE", 2);
        let time = Blockly.C.valueToCode(a, "TIME", 2);
        return `    SetSeeringEngineTime(${arg1},${arg2},${time});\r\n`;
    };
    Blockly.C.E3_motor_setSeeringEngineTime = function (a) {
        Blockly.C.include.SetSeeringEngineTime = '#include <SetSeeringEngineTime.h>';
        let arg1 = a.getFieldValue("PORT")
        let arg2 = Blockly.C.valueToCode(a, "ANGLE", 2);
        let time = Blockly.C.valueToCode(a, "TIME", 2);
        return `    SetSeeringEngineTime(${arg1},${arg2},${time});\r\n`;
    };
    Blockly.C.M6_motor_setSeeringEngineTime = function (a) {
        Blockly.C.include.SetSeeringEngineTime = '#include <SetSeeringEngineTime.h>';
        let arg1 = a.getFieldValue("PORT")
        let arg2 = Blockly.C.valueToCode(a, "ANGLE", 2);
        let time = Blockly.C.valueToCode(a, "TIME", 2);
        return `    SetSeeringEngineTime(${arg1},${arg2},${time});\r\n`;
    };



    //控制

    Blockly.C.math_positive_number = function (a) {
        let num = a.getFieldValue('NUM');
        return [num, 1];
    };
    Blockly.C.control_wait = function (a) {
        Blockly.C.include.SetWaitForTime = '#include <SetWaitForTime.h>';
        let time = Blockly.C.valueToCode(a, "DURATION", 1);
        return "    SetWaitForTime(" + time + ");\r\n";
    };
    Blockly.C.control_repeat = function (block) {
        let time = Blockly.C.valueToCode(block, "TIMES", 2);
        let branch = Blockly.C.statementToCode(block, "SUBSTACK");
        branch = branch ? (Blockly.C.addLoopTrap(branch, branch) || '') : '';
        return "    for(int i = 0; i < " + time + "; i++){\r\n" + branch + "    }\r\n";
    };
    Blockly.C.control_forever = function (block) {
        let branch = Blockly.C.statementToCode(block, "SUBSTACK");
        branch = Blockly.C.addLoopTrap(branch, branch) || '';
        return "    for(;;){\r\n" + branch + "    }\r\n";
    };
    Blockly.C.control_if = function (block) {
        let bool = Blockly.C.valueToCode(block, "CONDITION", 99) || "false";

        let branch = Blockly.C.statementToCode(block, "SUBSTACK");
        branch = Blockly.C.addLoopTrap(branch, branch) || '';
        return "    if (" + bool + "){\r\n" + branch + "    }\r\n";
    };
    Blockly.C.control_if_else = function (block) {
        let bool = Blockly.C.valueToCode(block, "CONDITION", 99) || "false";

        let branch1 = Blockly.C.statementToCode(block, "SUBSTACK", 2);
        branch1 = Blockly.C.addLoopTrap(branch1, branch1) || '';
        let branch2 = Blockly.C.statementToCode(block, "SUBSTACK2");
        branch2 = Blockly.C.addLoopTrap(branch2, branch2) || '';

        return "    if (" + bool + "){\r\n" + branch1 + "    } else {\r\n" + branch2 + "    }\r\n";
    };
    Blockly.C.control_wait_until = function (block) {
        let bool = Blockly.C.valueToCode(block, "CONDITION", 99);
        return "    while (!(" + bool + "));\r\n";
    };
    Blockly.C.control_repeat_until = function (block) {
        let bool = Blockly.C.valueToCode(block, "CONDITION", 99) || "false";
        let branch = Blockly.C.statementToCode(block, "SUBSTACK");
        branch = Blockly.C.addLoopTrap(branch, branch) || '';
        return "    while (!(" + bool + ")){\r\n" + branch + "    }\r\n";
    };


    //传感器

    Blockly.C.sensor_getTouch = function (a) {
        Blockly.C.include.GetTouch = '#include <GetTouch.h>';
        let prop = a.getFieldValue('SENSORPORT')
        return ['GetTouch(' + prop + ")", 1]
    };
    Blockly.C.sensor_colorDetection = function (a) {
        Blockly.C.include.GetColorSensor = '#include <GetColorSensor.h>';
        let prop = a.getFieldValue('COLORPORT')
        return ['GetColorSensor(' + prop + ",4)", 1]
    };
    Blockly.C.sensor_getUltrasonic = function (a) {
        Blockly.C.include.GetUltrasound = '#include <GetUltrasound.h>';
        let prop = a.getFieldValue('ULTRASONICPORT')
        return ['GetUltrasound(' + prop + ")", 1]
    };
    
    Blockly.C.sensor_getUltrasonicCompare = function (a) {
        Blockly.C.include.GetUltrasound = '#include <GetUltrasound.h>';
        let port = a.getFieldValue("PORT");
        let mode = a.getFieldValue("MODE");
        let data = Blockly.C.valueToCode(a, "DATA", 2);
        return [`GetUltrasound(${port}) ${mode} ${data}`, 1];
    };
    
    Blockly.C.sensor_colorDetectionCompare = function (a) {
        Blockly.C.include.GetColorSensor = '#include <GetColorSensor.h>';
        let port = a.getFieldValue("PORT");
        let mode = a.getFieldValue("MODE");
        return [`GetColorSensor(${port}, 4) == ${mode}`, 1];
    };

    Blockly.C.sensor_colorDetectionMode = function (a) {
        Blockly.C.include.GetColorSensor = '#include <GetColorSensor.h>';
        let port = a.getFieldValue("PORT");
        let mode = a.getFieldValue("MODE");
        return [`GetColorSensor(${port}, ${mode})`, 1];
    };

    Blockly.C.sensor_getLightSensor = function (a) {
        Blockly.C.include.GetLightSensor = '#include <GetLightSensor.h>';
        let prop = a.getFieldValue('SENSORPORT')
        return ['GetLightSensor(' + prop + ")", 1]
    };
    Blockly.C.sensor_getLightSensorDigital = function (a) {
        Blockly.C.include.GetLightSensorData = '#include <GetLightSensorData.h>';
        let prop = a.getFieldValue('SENSORPORT')
        return ['GetLightSensorData(' + prop + ")", 1]
    };
    Blockly.C.sensor_setLightSensor = function (a) {
        Blockly.C.include.SetLightSensorLed = '#include <SetLightSensorLed.h>';
        let prop = a.getFieldValue('SENSORPORT')
        let start = a.getFieldValue('STATE')
        return '    SetLightSensorLed(' + prop + "," + start + ");\r\n"
    };
    Blockly.C.sensor_setColorLamp = function (a) {
        Blockly.C.include.Set3CLed = '#include <Set3CLed.h>';
        let prop = a.getFieldValue('SENSORPORT')
        let color = a.getFieldValue('COLOR')
        return '    Set3CLed(' + prop + "," + color + ");\r\n"
    };
    Blockly.C.sensor_getgesture = function (a) {
        Blockly.C.include.GetGesture = '#include <GetGesture.h>';
        let prop = a.getFieldValue('PORT')
        return ['GetGesture(' + prop + ")", 1]
    };
    Blockly.C.sensor_getWifiCamRockCtrlNew = function (a) {
        Blockly.C.include.GetWifiCamRockCtrlNew = '#include <GetWifiCamRockCtrlNew.h>';
        let rockctrl = a.getFieldValue('ROCKCTRL')
        return ['GetWifiCamRockCtrlNew(' + rockctrl + ")", 1]
    };
    Blockly.C.sensor_getWifiPictureData = function (a) {
        Blockly.C.include.GetWifiPictureData = '#include <GetWifiPictureData.h>';
        let rockctrl = a.getFieldValue('PICTURE')
        return ['GetWifiPictureData(' + rockctrl + ")", 1]
    };
    Blockly.C.sensor_getCamRecogData = function (a) {
        Blockly.C.include.GetCamRecog = '#include <GetCamRecog.h>';
        let data = Blockly.C.valueToCode(a, "DATA", 1)
        return ['GetCamRecog(' + data + ")", 1]
    };
    Blockly.C.sensor_getWifiCamPictureResult = function (a) {
        Blockly.C.include.GetWifiCamPictureResult = '#include <GetWifiCamPictureResult.h>';
        let camdata = a.getFieldValue('CAMDATA')
        return ['GetWifiCamPictureResult(' + camdata + ")", 1]
    };
    Blockly.C.sensor_getWifiCamPictureSize = function (a) {
        Blockly.C.include.GetWifiCamPictureSize = '#include <GetWifiCamPictureSize.h>';
        let size = a.getFieldValue('SIZE')
        return ['GetWifiCamPictureSize(' + size + ")", 1]
    };
    Blockly.C.sensor_getWifiCamPictureSite = function (a) {
        Blockly.C.include.GetWifiCamPictureSite = '#include <GetWifiCamPictureSite.h>';
        let site = a.getFieldValue('SITE')
        return ['GetWifiCamPictureSite(' + site + ")", 1]
    };
    Blockly.C.sensor_getRFID = function (a) {
        Blockly.C.include.GetRFID522 = '#include <GetRFID522.h>';
        let port = a.getFieldValue("SENSORPORT");
        return ["GetRFID522(" + port + ")", 1];
    };
    Blockly.C.sensor_ReadRFIDData = function (a) {
        Blockly.C.include.ReadRFID522 = '#include <ReadRFID522.h>';
        let port = a.getFieldValue("SENSORPORT");
        return ["ReadRFID522(" + port + ")", 1];
    };

    Blockly.C.sensor_WriteRFIDData = function (a) {
        Blockly.C.include.WriteRFID522 = '#include <WriteRFID522.h>';
        let port = a.getFieldValue("SENSORPORT");
        let data = Blockly.C.valueToCode(a, "DATA", 2)
        return "    WriteRFID522(" + port + "," + data + ");\r\n";
    };


    // C1 RCU 特有的传感器积木块
    Blockly.C.sensor_getIRDist = function (a) {
        Blockly.C.include.GetIRDist = '#include <GetIRDist.h>';
        let arg1 = a.getFieldValue("IICDATA");
        return ["GetIRDist(" + arg1 + ")", 1]
    };

    // E3 RCU 特有的传感器积木块

    Blockly.C.sensor_setMusicPlayer = function (a) {
        Blockly.C.include.SetMusicPlayer = '#include <SetMusicPlayer.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("COMMAND");
        return "    SetMusicPlayer(" + arg1 + "," + arg2 + ");\r\n";
    };

    Blockly.C.sensor_setFan = function (a) {
        Blockly.C.include.SetFan = '#include <SetFan.h>';
        let arg1 = a.getFieldValue("MOTORPORT");
        let arg2 = Blockly.C.valueToCode(a, "SPEND", 2);
        return "    SetFan(" + arg1 + "," + arg2 + ");\r\n";
    };
    Blockly.C.sensor_getCompoI = function (a) {
        Blockly.C.include.GetCompoI = '#include <GetCompoI.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("MODE");
        return ["GetCompoI(" + arg1 + "," + arg2 + ")", 1]
    };
    Blockly.C.sensor_getIRDistE3 = function (a) {
        Blockly.C.include.GetIRDist = '#include <GetIRDist.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["GetIRDist(" + arg1 + ")", 1]
    };

    Blockly.C.sensor_getRemoIR = function (a) {
        Blockly.C.include.GetRemoIR = '#include <GetRemoIR.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["GetRemoIR(" + arg1 + ")", 1]
    };
    Blockly.C.sensor_getUltrasoundE3 = function (a) {
        Blockly.C.include.GetUltrasound = '#include <GetUltrasound.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("MODE");
        return ["GetUltrasound(" + arg1 + "," + arg2 + ")", 1]
    };
    Blockly.C.sensor_getCompassB = function (a) {
        Blockly.C.include.GetCompassB = '#include <GetCompassB.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["GetCompassB(" + arg1 + ")", 1]
    };
    Blockly.C.sensor_getGSensor = function (a) {
        Blockly.C.include.GetGSensor = '#include <GetGSensor.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("MODE");
        return ["GetGSensor(" + arg1 + "," + arg2 + ")", 1]
    };
    Blockly.C.sensor_getVolume = function (a) {
        Blockly.C.include.GetVolume = '#include <GetVolume.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["GetVolume(" + arg1 + ")", 1]
    };
    Blockly.C.sensor_getMagnet = function (a) {
        Blockly.C.include.GetMagnet = '#include <GetMagnet.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["GetMagnet(" + arg1 + ")", 1]
    };
    Blockly.C.sensor_getDTHSensor = function (a) {
        Blockly.C.include.GetDTHSensor = '#include <GetDTHSensor.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("MODE");
        return ["GetDTHSensor(" + arg1 + "," + arg2 + ")", 1]
    };
    Blockly.C.sensor_getAirQuality = function (a) {
        Blockly.C.include.GetAirQuality = '#include <GetAirQuality.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["GetAirQuality(" + arg1 + ")", 1]
    };
    Blockly.C.sensor_setAHRS = function (a) {
        Blockly.C.include.SetAHRS = '#include <SetAHRS.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("MODE");
        return "    SetAHRS(" + arg1 + "," + arg2 + ");\r\n";
    };
    Blockly.C.sensor_getAHRS = function (a) {
        Blockly.C.include.GetAHRS = '#include <GetAHRS.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("MODE");
        return ["GetAHRS(" + arg1 + "," + arg2 + ")", 1]
    };
    Blockly.C.sensor_getPhoto = function (a) {
        Blockly.C.include.GetPhoto = '#include <GetPhoto.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["GetPhoto(" + arg1 + ")", 1]
    };
    Blockly.C.sensor_getInfrared = function (a) {
        Blockly.C.include.GetInfrared = '#include <GetInfrared.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["GetInfrared(" + arg1 + ")", 1]
    };
    Blockly.C.sensor_getColorSensor = function (a) {
        Blockly.C.include.GetColorSensor = '#include <GetColorSensor.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("RGB");
        return ["GetColorSensor(" + arg1 + "," + arg2 + ")", 1]
    };
    Blockly.C.sensor_setIR = function (a) {
        Blockly.C.include.SetIR = '#include <SetIR.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.C.valueToCode(a, "STATUS", 2);
        return "    SetIR(" + arg1 + "," + arg2 + ");\r\n";
    };
    Blockly.C.sensor_getIRDete = function (a) {
        Blockly.C.include.GetIRDete = '#include <GetIRDete.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["GetIRDete(" + arg1 + ")", 1]
    };
    Blockly.C.sensor_setIRCode = function (a) {
        Blockly.C.include.SetIRCode = '#include <SetIRCode.h>';
        let arg1 = Blockly.C.valueToCode(a, "CODE", 1);
        return "    SetIRCode(" + arg1 + ");\r\n";
    };
    Blockly.C.sensor_getIRCode = function (a) {
        Blockly.C.include.GetIRCode = '#include <GetIRCode.h>';
        return ["GetIRCode(7)", 1]
    };
    Blockly.C.sensor_getTouchA = function (a) {
        Blockly.C.include.GetTouchA = '#include <GetTouchA.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["GetTouchA(" + arg1 + ")", 1]
    };
    Blockly.C.sensor_getTouchB = function (a) {
        Blockly.C.include.GetTouchB = '#include <GetTouchB.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["GetTouchB(" + arg1 + ")", 1]
    };
    Blockly.C.sensor_setIRBoard = function (a) {
        Blockly.C.include.SetIRBoard = '#include <SetIRBoard.h>';
        let arg1 = a.getFieldValue("SENSORPORT")
        let arg2 = Blockly.C.valueToCode(a, "ADDRESS", 2);
        let arg3 = a.getFieldValue("MODE")
        let arg4 = Blockly.C.valueToCode(a, "COLOR", 2);
        return "    SetIRBoard(" + arg1 + "," + arg2 + "," + arg3 + "," + arg4 + ");\r\n";
    };

    // M6 RCU 特有的传感器积木块

    Blockly.C.sensor_getRFID2 = function (a) {
        Blockly.C.include.GetRFID522 = '#include <GetRFID522.h>';
        let port = a.getFieldValue("SENSORPORT");
        return ["GetRFID522(" + port + ")", 1];
    };
    Blockly.C.sensor_ReadRFIDData2 = function (a) {
        Blockly.C.include.ReadRFID522 = '#include <ReadRFID522.h>';
        let port = a.getFieldValue("SENSORPORT");
        return ["ReadRFID522(" + port + ")", 1];
    };

    Blockly.C.sensor_WriteRFIDData2 = function (a) {
        Blockly.C.include.WriteRFID522 = '#include <WriteRFID522.h>';
        let port = a.getFieldValue("SENSORPORT");
        let data = Blockly.C.valueToCode(a, "DATA", 2)
        return "    WriteRFID522(" + port + "," + data + ");\r\n";
    };




    //AI

    Blockly.C.sensor_setAICamData = function (a) {
        Blockly.C.include.SetAICamData = '#include <SetAICamData.h>';
        let aimode = a.getFieldValue('AIMODE')
        let aimode2 = a.getFieldValue('AIMODE2') ? a.getFieldValue('AIMODE2') : 0
        return '    SetAICamData(' + aimode + "," + aimode2 + ");\r\n"
    };
    Blockly.C.sensor_getAICamData = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let data = a.getFieldValue('DATA')
        return ['GetAICamData(' + data + ")", 1]
    };
    Blockly.C.sensor_setWaitForAICamData = function (a) {
        Blockly.C.include.SetWaitForAICamData = '#include <SetWaitForAICamData.h>';
        let aimode = a.getFieldValue('AIMODE')
        let aimode2 = a.getFieldValue('AIMODE2') ? a.getFieldValue('AIMODE2') : 0
        return '    SetWaitForAICamData(' + aimode + "," + aimode2 + ");\r\n"
    };
    Blockly.C.sensor_getAICamDataColorDetect = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let color = a.getFieldValue('COLOR')
        return ['GetAICamData(' + color + ",0)", 1]
    };
    Blockly.C.sensor_getAICamDataQR = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let color = a.getFieldValue('COLOR')
        return ['GetAICamData(' + color + ",0)", 1]
    };
    Blockly.C.sensor_getAICamDataBall = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let color = a.getFieldValue('COLOR')
        return ['GetAICamData(' + color + ",0)", 1]
    };
    Blockly.C.sensor_getAICamDataRoad = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let color = a.getFieldValue('COLOR')
        return ['GetAICamData(' + color + ",0)", 1]
    };
    Blockly.C.sensor_getAICamDataFaceDetect = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let color = a.getFieldValue('COLOR')
        return ['GetAICamData(' + color + ",0)", 1]
    };
    Blockly.C.sensor_getAICamDataImage = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let color = a.getFieldValue('COLOR')
        return ['GetAICamData(' + color + ",0)", 1]
    };
    Blockly.C.sensor_getAICamDataImageLearning = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let color = a.getFieldValue('COLOR')
        return ['GetAICamData(' + color + ")", 1]
    };
    Blockly.C.sensor_getAICamDataGesture = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let color = a.getFieldValue('COLOR')
        return ['GetAICamData(' + color + ",0)", 1]
    };
    Blockly.C.sensor_getAICamDataApriltag = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let color = a.getFieldValue('COLOR')
        return ['GetAICamData(' + color + ",0)", 1]
    };
    Blockly.C.sensor_getAICamDataColorLearning = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let color = a.getFieldValue('COLOR')
        return ['GetAICamData(' + color + ",0)", 1]
    };
    Blockly.C.sensor_getAICamDataFaceLearning = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let color = a.getFieldValue('COLOR')
        return ['GetAICamData(' + color + ",0)", 1]
    };
    Blockly.C.sensor_getAICamVoice = function (a) {
        Blockly.C.include.GetAICamVoice = '#include <GetAICamVoice.h>';
        let order = a.getFieldValue('ORDER')
        return ['GetAICamVoice(' + order + ")", 1]
    };
    Blockly.C.sensor_getAIBrainData = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let color = a.getFieldValue('COLOR')
        return ['GetAICamData(' + color + ",0)", 1]
    };


    //显示

    Blockly.C.show_getTouchScreen = function (a) {
        Blockly.C.include.GetTouchScreen = '#include <GetTouchScreen.h>';
        return ['GetTouchScreen()', 1]
    };
    Blockly.C.show_getTouchScreenX = function (a) {
        Blockly.C.include.GetTouchScreenX = '#include <GetTouchScreenX.h>';
        return ['GetTouchScreenX()', 1]
    };
    Blockly.C.show_getTouchScreenY = function (a) {
        Blockly.C.include.GetTouchScreenY = '#include <GetTouchScreenY.h>';
        return ['GetTouchScreenY()', 1]
    };
    Blockly.C.show_LCDClearScreen = function (a) {
        Blockly.C.include.SetLCDClear = '#include <SetLCDClear.h>';
        let color = a.getFieldValue('COLOR')
        return '    SetLCDClear(' + color + ");\r\n"
    };
    Blockly.C.show_SetFontSize = function (a) {
        Blockly.C.include.SetFontSize = '#include <SetFontSize.h>';
        let fontsize = a.getFieldValue('FONTSIZE')
        return '    SetFontSize(' + fontsize + ");\r\n"
    };
    Blockly.C.show_setLineNum = function (a) {
        Blockly.C.include.SetDisplayVar = '#include <SetDisplayVar.h>';
        let lines = Blockly.C.valueToCode(a, "LINES", 2)
        let linenumber = Blockly.C.valueToCode(a, "LINENUMBER", 2)
        if (
            a.getInputTargetBlock("LINENUMBER") &&
            a.getInputTargetBlock("LINENUMBER").type == "data_itemoflist"
        ) {
            linenumber = `((int) ${linenumber})`
        }

        return '    SetDisplayVar(' + lines + "," + linenumber + ",0xFFE0,0x0000);\r\n"
    };
    Blockly.C.show_setColor = function (a) {
        Blockly.C.include.SetDisplayString = '#include <SetDisplayString.h>';
        let lines = Blockly.C.valueToCode(a, "LINES", 2)
        let text = Blockly.C.valueToCode(a, "TEXT", 2)
        text = Blockly.C.removeStar(a, "TEXT", text)
        // if (!/^"[\S\s]+"$/ig.test(text)) {
        //     text = '"' + text + '"'
        // }
        return '    SetDisplayString(' + lines + "," + text + ",0xFFE0,0x0000);\r\n"
    };
    Blockly.C.show_drawImage = function (a) {
        Blockly.C.include.SetDisplayPicture = '#include <SetDisplayPicture.h>';
        let x = Blockly.C.valueToCode(a, "IMAGEX", 2)
        let y = Blockly.C.valueToCode(a, "IMAGEY", 2)
        let filename = Blockly.C.valueToCode(a, "IMAGEFILENAME", 2)
        let scale = Blockly.C.valueToCode(a, "IMAGESCALE", 2)
        return '    SetDisplayPicture(' + x + "," + y + "," + filename + "," + scale + ");\r\n"
    };
    Blockly.C.show_diplayData = function (a) {
        Blockly.C.include.SetDisplayVarXY = '#include <SetDisplayVarXY.h>';
        let x = Blockly.C.valueToCode(a, "X", 2)
        let y = Blockly.C.valueToCode(a, "Y", 2)
        let data = Blockly.C.valueToCode(a, "DATA", 2)
        let color = a.getFieldValue("COLOR")
        let backgroundcolor = a.getFieldValue("BACKGROUNDCOLOR")
        return '    SetDisplayVarXY(' + x + "," + y + "," + data + "," + color + "," + backgroundcolor + ");\r\n"
    };
    Blockly.C.show_displayCharacter = function (a) {
        Blockly.C.include.SetDisplayStringXY = '#include <SetDisplayStringXY.h>';
        let x = Blockly.C.valueToCode(a, "X", 2)
        let y = Blockly.C.valueToCode(a, "Y", 2)
        let text = Blockly.C.valueToCode(a, "CHARACTER", 2)
        text = Blockly.C.removeStar(a, "CHARACTER", text)
        if (!/^"[\S\s]+"$/ig.test(text)) {
            text = '"' + text + '"'
        }

        let color = a.getFieldValue("COLOR")
        let backgroundcolor = a.getFieldValue("BACKGROUNDCOLOR")
        let transparent = a.getFieldValue("TRANSPARENT")
        return '    SetDisplayStringXY(' + x + "," + y + "," + text + "," + color + "," + backgroundcolor + "," + transparent + ");\r\n"
    };
    Blockly.C.show_drawPoint = function (a) {
        Blockly.C.include.SetLCDDot = '#include <SetLCDDot.h>';
        let x = Blockly.C.valueToCode(a, "POINTX", 2)
        let y = Blockly.C.valueToCode(a, "POINTY", 2)
        let color = a.getFieldValue("POINTCOLOR")
        return '    SetLCDDot(' + x + "," + y + "," + color + ");\r\n"
    };
    Blockly.C.show_drawLine = function (a) {
        Blockly.C.include.SetLCDLine = '#include <SetLCDLine.h>';
        let x = Blockly.C.valueToCode(a, "LINEX", 2)
        let y = Blockly.C.valueToCode(a, "LINEY", 2)
        let lineangle = Blockly.C.valueToCode(a, "LINEANGLE", 2)
        let linelength = Blockly.C.valueToCode(a, "LINELENGTH", 2)
        let color = a.getFieldValue("LINECOLOR")
        return '    SetLCDLine(' + x + "," + y + "," + lineangle + "," + linelength + "," + color + ");\r\n"
    };
    Blockly.C.show_drawCircle = function (a) {
        Blockly.C.include.SetLCDSolidCircle = '#include <SetLCDSolidCircle.h>';
        let x = Blockly.C.valueToCode(a, "CIRCLEX", 2)
        let y = Blockly.C.valueToCode(a, "CIRCLEY", 2)
        let circleradius = Blockly.C.valueToCode(a, "CIRCLERADIUS", 2)
        let color = a.getFieldValue("CIRCLECOLOR")
        return '    SetLCDSolidCircle(' + x + "," + y + "," + circleradius + "," + color + ");\r\n"
    };
    Blockly.C.show_drawRectangle = function (a) {
        Blockly.C.include.SetLCDRectangle2 = '#include <SetLCDRectangle2.h>';
        let x = Blockly.C.valueToCode(a, "RECTANGLEX", 2)
        let y = Blockly.C.valueToCode(a, "RECTANGLEY", 2)
        let rectanglewitdh = Blockly.C.valueToCode(a, "RECTANGLEWIDTH", 2)
        let rectangleheight = Blockly.C.valueToCode(a, "RECTANGLEHEIGHT", 2)
        let rectanglelinewidth = Blockly.C.valueToCode(a, "RECTANGLELINEWIDTH", 2)
        let color = a.getFieldValue("RECTANGLECOLOR")
        return '    SetLCDRectangle2(' + x + "," + y + "," + rectanglewitdh + "," + rectangleheight + "," + rectanglelinewidth + "," + color + ");\r\n"
    };
    Blockly.C.show_drawSolidRectangle = function (a) {
        Blockly.C.include.SetLCDFilledRectangle2 = '#include <SetLCDFilledRectangle2.h>';
        let x = Blockly.C.valueToCode(a, "SOLIDRECTANGLEX", 2)
        let y = Blockly.C.valueToCode(a, "SOLIDRECTANGLEY", 2)
        let solidrectanglewidth = Blockly.C.valueToCode(a, "SOLIDRECTANGLEWIDTH", 2)
        let solidrectangleheight = Blockly.C.valueToCode(a, "SOLIDRECTANGLEHEIGHT", 2)
        let color = a.getFieldValue("SOLIDRECTANGLECOLOR")
        return '    SetLCDFilledRectangle2(' + x + "," + y + "," + solidrectanglewidth + "," + solidrectangleheight + "," + color + ");\r\n"
    };

    Blockly.C.show_setDisplayVarU32 = function (a) {
        Blockly.C.include.SetDisplayVarU32 = '#include <SetDisplayVarU32.h>';
        let line = Blockly.C.valueToCode(a, "LINE", 2);
        let value = Blockly.C.valueToCode(a, "VALUE", 2);
        let fontColor = a.getFieldValue("FONTCOLOR");
        let bgColor = a.getFieldValue("BGCOLOR");
        return `    SetDisplayVarU32(${line},${value},${fontColor},${bgColor});\r\n`;
    };
    Blockly.C.show_setDisplayFloat = function (a) {
        Blockly.C.include.SetDisplayFloat = '#include <SetDisplayFloat.h>';
        let line = Blockly.C.valueToCode(a, "LINE", 2);

        let value = Blockly.C.valueToCode(a, "VALUE", 2);

        let fontColor = a.getFieldValue("FONTCOLOR");
        let bgColor = a.getFieldValue("BGCOLOR");
        return `    SetDisplayFloat(${line},${value},${fontColor},${bgColor});\r\n`;
    };


    // E3 RCU 特有的显示积木块

    Blockly.C.show_setLCDBack = function (a) {
        Blockly.C.include.SetLCDBack = '#include <SetLCDBack.h>';
        let arg1 = a.getFieldValue("SWITCH")
        return '    SetLCDBack(' + arg1 + ");\r\n"
    };




    //播放

    Blockly.C.play_playMP3 = function (a) {
        Blockly.C.include.SetMp3Play = '#include <SetMp3Play.h>';
        let foldername = Blockly.C.valueToCode(a, "FOLDERNAME", 2)
        let musicname = Blockly.C.valueToCode(a, "MUSICNAME", 2)
        foldername = foldername.replace(/'|"/ig, "")
        musicname = musicname.replace(/'|"/ig, "")
        return '    SetMp3Play(' + foldername + "," + musicname + ");\r\n"
    };
    Blockly.C.play_pausePlayback = function (a) {
        Blockly.C.include.SetMp3Suspend = '#include <SetMp3Suspend.h>';
        return '    SetMp3Suspend();\r\n'
    };
    Blockly.C.play_playSound = function (a) {
        Blockly.C.include.SetMp3Play = '#include <SetMp3Play.h>';
        let sound = a.getFieldValue('SOUND')
        return '    SetMp3Play(1, ' + sound + ");\r\n"
    };

    Blockly.C.play_setMp3Sound = function (a) {
        let value = a.getFieldValue("VALUE");
        return "    SetMp3Sound(" + value + ");\r\n";
    };


    //无线
    Blockly.C.wireless_getRCUBleData = function (a) {
        Blockly.C.include.GetBluetoothData = '#include <GetBluetoothData.h>';
        return ['GetBluetoothData()', 1]
    };
    Blockly.C.wireless_RCUSendBluetoothData = function (a) {
        Blockly.C.include.SetBluetoothData = '#include <SetBluetoothData.h>';
        let data = Blockly.C.valueToCode(a, "DATA", 1)
        return '    SetBluetoothData(' + data + ');\r\n'
    };
    Blockly.C.wireless_getComVoice = function (a) {
        Blockly.C.include.GetComVoice = '#include <GetComVoice.h>';
        let text = Blockly.C.valueToCode(a, "TEXT", 1)
        return ['GetComVoice(' + text + ')', 1]
    };
    Blockly.C.wireless_getBluetoothControl = function (a) {
        Blockly.C.include.GetBluetoothControl = '#include <GetBluetoothControl.h>';
        return ['GetBluetoothControl()', 1]
    };
    Blockly.C.wireless_getBluetoothControlData = function (a) {
        Blockly.C.include.GetBluetoothControlData = '#include <GetBluetoothControlData.h>';
        return ['GetBluetoothControlData()', 1]
    };
    Blockly.C.wireless_getBluetoothButton = function (a) {
        Blockly.C.include.GetBTModuleRemoteButton = '#include <GetBTModuleRemoteButton.h>';
        return ['GetBTModuleRemoteButton()', 1]
    };
    Blockly.C.wireless_getBluetoothCode = function (a) {
        Blockly.C.include.GetBTModuleRemoteCode = '#include <GetBTModuleRemoteCode.h>';
        return ['GetBTModuleRemoteCode()', 1]
    };
    Blockly.C.wireless_getBluetoothRocker = function (a) {
        Blockly.C.include.GetBTModuleRemoteRocker = '#include <GetBTModuleRemoteRocker.h>';
        let direction = a.getFieldValue('DIRECTION')
        let axis = a.getFieldValue('AXIS')
        return ['GetBTModuleRemoteRocker(' + direction + ',' + axis + ')', 1]
    };

    // C1 RCU 特有的无线积木块

    Blockly.C.wireless_getIRCode = function (a) {
        Blockly.C.include.GetIRCode = '#include <GetIRCode.h>';
        return ['GetIRCode(7)', 1]
    };

    // E3 RCU 特有的无线积木块

    Blockly.C.wireless_getWifiRemote = function (a) {
        Blockly.C.include.GetWifiRemote = '#include <GetWifiRemote.h>';
        let arg1 = Blockly.C.valueToCode(a, "KEY", 1)
        return ['GetWifiRemote(' + arg1 + ')', 1]
    };
    Blockly.C.wireless_getWifiVoice = function (a) {
        Blockly.C.include.GetWifiVoice = '#include <GetWifiVoice.h>';
        let arg1 = Blockly.C.valueToCode(a, "TEXT", 1)
        return ['GetWifiVoice(' + arg1 + ')', 1]
    };
    Blockly.C.wireless_setWifiVoiceString = function (a) {
        Blockly.C.include.SetWifiVoiceString = '#include <SetWifiVoiceString.h>';
        let arg1 = Blockly.C.valueToCode(a, "LINE", 2)
        let arg2 = a.getFieldValue("TEXTCOLOR")
        let arg3 = a.getFieldValue("BGCOLOR")

        return '    SetWifiVoiceString(' + arg1 + "," + arg2 + "," + arg3 + ');\r\n';
    };
    Blockly.C.wireless_getWifiPutter = function (a) {
        Blockly.C.include.GetWifiPutter = '#include <GetWifiPutter.h>';
        let arg1 = a.getFieldValue("DIRECTION")
        return ['GetWifiPutter(' + arg1 + ')', 1]
    };
    Blockly.C.wireless_setWifiUdpMode = function (a) {
        Blockly.C.include.SetWifiUdpMode = '#include <SetWifiUdpMode.h>';
        let arg1 = Blockly.C.valueToCode(a, "IP", 2)
        let arg2 = Blockly.C.valueToCode(a, "TELEPORT", 2)
        let arg3 = Blockly.C.valueToCode(a, "LOCALPORT", 2)

        return '    SetWifiUdpMode(' + arg1 + "," + arg2 + "," + arg3 + ');\r\n';
    };
    Blockly.C.wireless_setWifiData = function (a) {
        Blockly.C.include.SetWifiData = '#include <SetWifiData.h>';
        let arg1 = Blockly.C.valueToCode(a, "DATA", 1)

        return '    SetWifiData(' + arg1 + ');\r\n';
    };
    Blockly.C.wireless_getWifiData = function (a) {
        Blockly.C.include.GetWifiData = '#include <GetWifiData.h>';
        return ['GetWifiData()', 1]
    };






    // 巡线函数 积木块

    Blockly.C.trackfunction_speedcontrol = function (a) {
        Blockly.C.include.speedcontrol = '#include <speedcontrol.h>';

        let arg1 = Blockly.C.valueToCode(a, "LEFTSPEED", 2)
        let arg2 = Blockly.C.valueToCode(a, "RIGHTSPEED", 2)

        return '    speedcontrol(' + arg1 + ',' + arg2 + ');\r\n';
    };
    Blockly.C.trackfunction_line_bmp = function (a) {
        Blockly.C.include.line_bmp = '#include <line_bmp.h>';

        let arg1 = Blockly.C.valueToCode(a, "SPEED", 2)
        let arg2 = Blockly.C.valueToCode(a, "TIME", 2)

        return '    line_bmp(' + arg1 + ',' + arg2 + ');\r\n';
    };
    Blockly.C.trackfunction_catch_line = function (a) {
        Blockly.C.include.catch_line = '#include <catch_line.h>';

        let arg1 = Blockly.C.valueToCode(a, "SPEED", 2)
        let arg2 = Blockly.C.valueToCode(a, "LIGHT", 2)

        return '    catch_line(' + arg1 + ',' + arg2 + ');\r\n';
    };
    Blockly.C.trackfunction_turn_angle = function (a) {
        Blockly.C.include.turn_angle = '#include <turn_angle.h>';

        let arg1 = Blockly.C.valueToCode(a, "SPEED", 2)
        let arg2 = Blockly.C.valueToCode(a, "TIME", 2)

        return '    turn_angle(' + arg1 + ',' + arg2 + ');\r\n';
    };
    Blockly.C.trackfunction_go_bmp = function (a) {
        Blockly.C.include.go_bmp = '#include <go_bmp.h>';

        let arg1 = Blockly.C.valueToCode(a, "SPEED", 2)
        let arg2 = Blockly.C.valueToCode(a, "TIME", 2)

        return '    go_bmp(' + arg1 + ',' + arg2 + ');\r\n';
    };
    Blockly.C.trackfunction_goline = function (a) {
        Blockly.C.include.goline = '#include <goline.h>';

        let arg1 = Blockly.C.valueToCode(a, "SPEED", 1)

        return '    goline(' + arg1 + ');\r\n';
    };
    Blockly.C.trackfunction_turnleft = function (a) {
        Blockly.C.include.turnleft = '#include <turnleft.h>';

        let arg1 = Blockly.C.valueToCode(a, "SPEED", 1)

        return '    turnleft(' + arg1 + ');\r\n';
    };
    Blockly.C.trackfunction_turnright = function (a) {
        Blockly.C.include.turnright = '#include <turnright.h>';

        let arg1 = Blockly.C.valueToCode(a, "SPEED", 1)

        return '    turnright(' + arg1 + ');\r\n';
    };
    Blockly.C.trackfunction_turn_w = function (a) {
        Blockly.C.include.turn_w = '#include <turn_w.h>';

        let arg1 = Blockly.C.valueToCode(a, "LEFTMOTOR", 2)
        let arg2 = Blockly.C.valueToCode(a, "RIGHTMOTOR", 2)
        let arg3 = Blockly.C.valueToCode(a, "LIGHT", 2)

        return '    turn_w(' + arg1 + ',' + arg2 + ',' + arg3 + ');\r\n';
    };
    Blockly.C.trackfunction_SetLightSensorThreshold = function (a) {
        Blockly.C.include.SetLightSensorThreshold = '#include <SetLightSensorThreshold.h>';

        let arg1 = Blockly.C.valueToCode(a, "PORT", 2)
        let arg2 = Blockly.C.valueToCode(a, "DATA", 2)

        return '    SetLightSensorThreshold(' + arg1 + ',' + arg2 + ');\r\n';
    };


    // M5 控制器

    Blockly.C.motor_M5_setMotor = function (a, b, c) {
        Blockly.C.include.SetMotor = '#include <SetMotor.h>';
        let motorport = a.getFieldValue("MOTORPORT");
        let value = Blockly.C.valueToCode(a, "VALUE", 2);
        return "    SetMotor(" + motorport + "," + value + ")\r\n";
    };
    Blockly.C.motor_M5_SetServo = function (a, b, c) {
        Blockly.C.include.SetServo = '#include <SetServo.h>';
        let motorport = a.getFieldValue("MOTORPORT");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 2);
        return "    SetServo(" + motorport + "," + angle + ")\r\n";
    };

    Blockly.C.sensor_M5_GetButton = function (a, b, c) {
        Blockly.C.include.GetButton = '#include <GetButton.h>';
        let port = a.getFieldValue("PORT");
        return [`GetButton(${port})`, 1];
    };

    Blockly.C.sensor_M5_GetLightSensor = function (a, b, c) {
        Blockly.C.include.GetLightSensor = '#include <GetLightSensor.h>';
        let port = a.getFieldValue("PORT");
        return [`GetLightSensor(${port})`, 1];
    };
    Blockly.C.sensor_M5_Set3CLed = function (a, b, c) {
        Blockly.C.include.Set3CLed = '#include <Set3CLed.h>';
        let port = a.getFieldValue("PORT");
        let color = a.getFieldValue("COLOR");

        return `    Set3CLed(${port},${color})\r\n`;
    };

    Blockly.C.sensor_M5_GetMIC = function (a, b, c) {
        Blockly.C.include.GetMIC = '#include <GetMIC.h>';
        let port = a.getFieldValue("PORT");
        return [`GetMIC(${port})`, 1];
    };
    Blockly.C.sensor_M5_GetPotentiometer = function (a, b, c) {
        Blockly.C.include.GetPotentiometer = '#include <GetPotentiometer.h>';
        let port = a.getFieldValue("PORT");
        return [`GetPotentiometer(${port})`, 1];
    };
    Blockly.C.sensor_M5_GetTiltAxis = function (a, b, c) {
        Blockly.C.include.GetTiltAxis = '#include <GetTiltAxis.h>';
        let port = a.getFieldValue("PORT");
        let axis = a.getFieldValue("AXIS");
        return [`GetTiltAxis(${port},${axis})`, 1];
    };

    // M5 无线
    Blockly.C.wireless_M5_GetRFModuleRemoteButton = function (a, b, c) {
        Blockly.C.include.GetRFModuleRemoteButton = '#include <GetRFModuleRemoteButton.h>';
        let port = a.getFieldValue("PORT");
        return [`GetRFModuleRemoteButton(${port})`, 1];
    };
    Blockly.C.wireless_M5_GetRFModuleRemoteCode = function (a, b, c) {
        Blockly.C.include.GetRFModuleRemoteCode = '#include <GetRFModuleRemoteCode.h>';
        let port = a.getFieldValue("PORT");
        return [`GetRFModuleRemoteCode(${port})`, 1];
    };
    Blockly.C.wireless_M5_GetRFModuleRemoteRocker = function (a, b, c) {
        Blockly.C.include.GetRFModuleRemoteRocker = '#include <GetRFModuleRemoteRocker.h>';
        let port = a.getFieldValue("PORT");
        let direction = a.getFieldValue("DIRECTION");
        let axis = a.getFieldValue("AXIS");
        return [`GetRFModuleRemoteRocker(${port},${direction},${axis})`, 1];
    };



    // 扩展： 传感器
    Blockly.C.extSensor_setAttitude = function (a) {
        Blockly.C.include.SetAHRS = '#include <SetAHRS.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("SETATTITUDEMODE");
        return "    SetAHRS(" + arg1 + "," + arg2 + ");\r\n";
    };
    Blockly.C.extSensor_getAttitude = function (a) {
        Blockly.C.include.GetAHRS = '#include <GetAHRS.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("ATTITUDEMODE");
        return ["GetAHRS(" + arg1 + "," + arg2 + ",0)", 1];
    };

    Blockly.C.extSensor_LaserDist = function (a) {
        Blockly.C.include.GetLaserDist = '#include <GetLaserDist.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("LASERDISTMODE");
        return ["GetLaserDist(" + arg1 + "," + arg2 + ")", 1];
    };
    Blockly.C.extSensor_ShortIRDist = function (a) {
        Blockly.C.include.GetShortIRDist = '#include <GetShortIRDist.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["GetShortIRDist(" + arg1 + ")", 1];
    };
    Blockly.C.extSensor_Gesture = function (a) {
        Blockly.C.include.GetGesture = '#include <GetGesture.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["GetGesture(" + arg1 + ")", 1];
    };
    Blockly.C.extSensor_sensor_getAirPressure = function (a) {
        Blockly.C.include.GetAirPressure = '#include <GetAirPressure.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["GetAirPressure(" + arg1 + ")", 1];
    };
    Blockly.C.extSensor_sensor_getSht30 = function (a) {
        Blockly.C.include.GetSht30 = '#include <GetSht30.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("COMMAND");
        return ["GetSht30(" + arg1 + "," + arg2 + ")", 1];
    };
    Blockly.C.extSensor_sensor_getMagnetic = function (a) {
        Blockly.C.include.GetMagnetic = '#include <GetMagnetic.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("MODEL");
        return ["GetMagnetic(" + arg1 + "," + arg2 + ")", 1];
    };
    Blockly.C.extSensor_sensor_getScanCamera = function (a) {
        Blockly.C.include.GetScanCamera = '#include <GetScanCamera.h>';
        return ["GetScanCamera()", 1];
    };
    Blockly.C.extSensor_sensor_getComStrCompare = function (a) {
        Blockly.C.include.GetComStrCompare = '#include <GetComStrCompare.h>';
        let value = Blockly.C.valueToCode(a, "VALUE", 2);
        return [`GetComStrCompare(${value})`, 1];
    };
    Blockly.C.extSensor_smartEyeDist = function (a) {
        Blockly.C.include.GetSmartEyeDist = '#include <GetSmartEyeDist.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["GetSmartEyeDist(" + arg1 + ")", 1];
    };
    Blockly.C.extSensor_smartEyeIRCode = function (a) {
        Blockly.C.include.GetSmartEyeIRcode = '#include <GetSmartEyeIRcode.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["GetSmartEyeIRcode(" + arg1 + ")", 1];
    };
    Blockly.C.extSensor_setSmartEyeIRCode = function (a) {
        Blockly.C.include.SetSmartEyeIRcode = '#include <SetSmartEyeIRcode.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.C.valueToCode(a, "VALUE", 2);
        return "    SetSmartEyeIRcode(" + arg1 + "," + arg2 + ");\r\n";
    };
    Blockly.C.extSensor_setSmartEye = function (a) {
        Blockly.C.include.SetSmartEyeMode = '#include <SetSmartEyeMode.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("SMARTEYEMODE");

        let arg3 = Blockly.C.valueToCode(a, "COLOR", 2);
        arg3 = Blockly.C.transformColor(arg3) //转换成 0x的形式

        return "    SetSmartEyeMode(" + arg1 + "," + arg2 + "," + arg3 + ");\r\n";
    };
    Blockly.C.extSensor_setSmartEyeAllLed = function (a) {
        Blockly.C.include.SetSmartEyeAllLed = '#include <SetSmartEyeAllLed.h>';
        let arg1 = a.getFieldValue("SENSORPORT");

        let arg2 = Blockly.C.valueToCode(a, "COLOR1", 2);
        arg2 = Blockly.C.transformColor(arg2) //转换成 0x的形式

        let arg3 = Blockly.C.valueToCode(a, "COLOR2", 2);
        arg3 = Blockly.C.transformColor(arg3) //转换成 0x的形式

        let arg4 = Blockly.C.valueToCode(a, "COLOR3", 2);
        arg4 = Blockly.C.transformColor(arg4) //转换成 0x的形式

        let arg5 = Blockly.C.valueToCode(a, "COLOR4", 2);
        arg5 = Blockly.C.transformColor(arg5) //转换成 0x的形式

        let arg6 = Blockly.C.valueToCode(a, "COLOR5", 2);
        arg6 = Blockly.C.transformColor(arg6) //转换成 0x的形式

        let arg7 = Blockly.C.valueToCode(a, "COLOR6", 2);
        arg7 = Blockly.C.transformColor(arg7) //转换成 0x的形式

        let arg8 = Blockly.C.valueToCode(a, "COLOR7", 2);
        arg8 = Blockly.C.transformColor(arg8) //转换成 0x的形式

        let arg9 = Blockly.C.valueToCode(a, "COLOR8", 2);
        arg9 = Blockly.C.transformColor(arg9) //转换成 0x的形式

        return "    SetSmartEyeAllLed(" + arg1 + "," + arg2 + "," + arg3 + "," + arg4 + "," + arg5 + "," + arg6 + "," + arg7 + "," + arg8 + "," + arg9 + ");\r\n";
    };
    Blockly.C.extSensor_SetDisplayLatticeClear = function (a) {
        Blockly.C.include.SetDisplayLatticeClear = '#include <SetDisplayLatticeClear.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return "    SetDisplayLatticeClear(" + arg1 + ");\r\n";
    };
    Blockly.C.extSensor_SetDisplayLatticePic = function (a) {
        Blockly.C.include.SetDisplayLatticePic = '#include <SetDisplayLatticePic.h>';
        let arg1 = a.getFieldValue("SENSORPORT");

        let arg2 = Blockly.C.valueToCode(a, "MATRIX", 2);
        arg2 = arg2.length == 256 ? '"' + Blockly.C.matrixToString16(arg2) + '"' : arg2

        let arg3 = a.getFieldValue("LIGHTNESS");

        return "    SetDisplayLatticePic(" + arg1 + "," + arg2 + "," + arg3 + ");\r\n";
    };
    Blockly.C.extSensor_SetDisplayLattice = function (a) {
        Blockly.C.include.SetDisplayLattice = '#include <SetDisplayLattice.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.C.valueToCode(a, "VALUE", 2);
        if (!/^"[\S\s]+"$/ig.test(arg2)) {
            arg2 = '"' + arg2 + '"'
        }
        let arg3 = a.getFieldValue("LIGHTNESS");
        return "    SetDisplayLattice(" + arg1 + "," + arg2 + "," + arg3 + ");\r\n";
    };
    Blockly.C.extSensor_SetDisplayLatticeXY = function (a) {
        Blockly.C.include.SetDisplayLatticeXY = '#include <SetDisplayLatticeXY.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.C.valueToCode(a, "X", 2);
        let arg3 = Blockly.C.valueToCode(a, "Y", 2);
        let arg4 = a.getFieldValue("STATES");
        let arg5 = a.getFieldValue("LIGHTNESS");
        return "    SetDisplayLatticeXY(" + arg1 + "," + arg2 + "," + arg3 + "," + arg4 + "," + arg5 + ");\r\n";
    };
    Blockly.C.extSensor_SetDisplayLatticeString = function (a) {
        Blockly.C.include.SetDisplayLatticeString = '#include <SetDisplayLatticeString.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.C.valueToCode(a, "STRING", 2);
        if (!/^"[\S\s]+"$/ig.test(arg2)) {
            arg2 = '"' + arg2 + '"'
        }
        let arg3 = a.getFieldValue("DIRECTION");
        let arg4 = Blockly.C.valueToCode(a, "SPEED", 2);
        let arg5 = a.getFieldValue("LIGHTNESS");
        return "    SetDisplayLatticeString(" + arg1 + "," + arg2 + "," + arg3 + "," + arg4 + "," + arg5 + ");\r\n";
    };

    Blockly.C.extSensor_sensor_getTraceV2I2C = function (a) {
        Blockly.C.include.GetTraceV2I2C = '#include <GetTraceV2I2C.h>';
        let port = a.getFieldValue("SENSORPORT");
        let cmd = a.getFieldValue("PASSAGEWAY");
        return [`GetTraceV2I2C(${port},${cmd})`, 1]
    };
    Blockly.C.extSensor_sensor_getTraceV2I2CState = function (a) {
        Blockly.C.include.GetTraceV2I2CState = '#include <GetTraceV2I2CState.h>';
        let port = a.getFieldValue("SENSORPORT");
        let cmd = a.getFieldValue("STATEDATA");
        return [`GetTraceV2I2CState(${port},${cmd})`, 1]
    };

    
    Blockly.C.extSensor_sensor_M5_getTraceV2I2CState = function (a) {
        Blockly.C.include.GetTraceV2I2CState = '#include <GetTraceV2I2CState.h>';
        let prop = a.getFieldValue("SENSORPORT");
        let channel = Blockly.C.valueToCode(a, "CHANNEL", 2);
        return [`GetTraceV2I2CState(${prop},${channel})`, 1];
    };
    Blockly.C.extSensor_sensor_M5_GetTraceV2I2CChxState = function (a) {
        Blockly.C.include.GetTraceV2I2CChxState = '#include <GetTraceV2I2CChxState.h>';
        let prop = a.getFieldValue("SENSORPORT");
        let status = a.getFieldValue("INTERSECTIONSTATUS");
        return [`GetTraceV2I2CChxState(${prop},${status})`, 1];
    };
    Blockly.C.extSensor_sensor_M5_SetTraceV2I2Color = function (a) {
        Blockly.C.include.SetTraceV2I2Color = '#include <SetTraceV2I2Color.h>';
        let prop = a.getFieldValue("SENSORPORT");
        let color1 = Blockly.C.valueToCode(a, "COLOUR1", 2);
        let color2 = Blockly.C.valueToCode(a, "COLOUR2", 2);
        let color3 = Blockly.C.valueToCode(a, "COLOUR3", 2);
        let color4 = Blockly.C.valueToCode(a, "COLOUR4", 2);
        let color5 = Blockly.C.valueToCode(a, "COLOUR5", 2);
        let color6 = Blockly.C.valueToCode(a, "COLOUR6", 2);
        let color7 = Blockly.C.valueToCode(a, "COLOUR7", 2);
        return `    SetTraceV2I2Color(${prop},${color1},${color2},${color3},${color4},${color5},${color6},${color7});\r\n`;
    };
    Blockly.C.extSensor_sensor_M5_SetTraceV2I2AllColor = function (a) {
        Blockly.C.include.SetTraceV2I2AllColor = '#include <SetTraceV2I2AllColor.h>';
        let prop = a.getFieldValue("SENSORPORT");
        let color = Blockly.C.valueToCode(a, "COLOUR", 2);
        return `    SetTraceV2I2AllColor(${prop},${color});\r\n`;
    };
    Blockly.C.extSensor_sensor_M5_SetTraceV2I2Threshold = function (a) {
        Blockly.C.include.SetTraceV2I2Threshold = '#include <SetTraceV2I2Threshold.h>';
        let prop = a.getFieldValue("SENSORPORT");
        let seconds = Blockly.C.valueToCode(a, "SECONDS", 2);
        return `    SetTraceV2I2Threshold(${prop},${seconds});\r\n`;
    };
    Blockly.C.extSensor_sensor_M5_SetTraceV2I2CLineColor = function (a) {
        Blockly.C.include.SetTraceV2I2CLineColor = '#include <SetTraceV2I2CLineColor.h>';
        let prop = a.getFieldValue("SENSORPORT");
        let color = Blockly.C.valueToCode(a, "COLOUR", 2);
        return `    SetTraceV2I2CLineColor(${prop},${color});\r\n`;
    };

    
    Blockly.C.extSensor_menu_CHANNELMENUS = function (a) {
        let channel = a.getFieldValue("CHANNELMENUS") || "";
        return [channel, 1];
    };
    Blockly.C.extSensor_menu_INTERSECTIONSTATUS = function (a) {
        let colours = a.getFieldValue("INTERSECTIONSTATUS") || "";
        return [colours, 1];
    };
    Blockly.C.extSensor_menu_colorMenus = function (a) {
        let colours = a.getFieldValue("colorMenus") || "";
        return [colours, 1];
    };
    Blockly.C.extSensor_menu_colorMenus2 = function (a) {
        let colours = a.getFieldValue("colorMenus2") || "";
        return [colours, 1];
    };


    Blockly.C.extSensor_SetPump = function (a) {
        Blockly.C.include.SetPump = '#include <SetPump.h>';
        let port = a.getFieldValue("SENSORPORT");
        let status = a.getFieldValue("SWITCH");

        return `    SetPump(${port},${status});\r\n`
    };


    // 扩展iot
    
    Blockly.C.extIot_SetIOTConfig = function (a) {
        Blockly.C.include.SetIOTConfig = '#include <SetIOTConfig.h>';
        Blockly.C.include.SetIOTTopic = '#include <SetIOTTopic.h>';
        let config = a.getFieldValue("CONFIG");
        let cmd = []
        config = JSON.parse(config)
        let port = a.getFieldValue("SENSORPORT");
        cmd.push(`    SetIOTConfig(${port},"${config.wifi_name}","${config.wifi_pwd}","${config.iot_id}","${config.iot_pwd}","${config.server_ip}");\r\n`)
        
        for(let i=0; i < config.Topics.length; i++){
            cmd.push(`    SetIOTTopic(${port},"${config.Topics[i]}");\r\n`)
        }
        Blockly.C.IotConfig[port] = config.Topics
        
        return cmd.join("");
    };

    
    Blockly.C.extIot_GetIOTData = function (a) {
        Blockly.C.include.GetIOTData = '#include <GetIOTData.h>';
        let topicIndex = a.getFieldValue("TOPIC");
        let port = a.getFieldValue("SENSORPORT");
        let value = Blockly.C.valueToCode(a, "VALUE", 2) || '""';
        if(!isNaN(Number(value))){
            value = `"${value}"`
        }

        let data = ""
        if(Blockly.C.IotConfig[port]){
            let topicData = Blockly.C.IotConfig[port]
            if(topicData[topicIndex]){
                data = topicData[topicIndex]
            }
        }
        
        return [`GetIOTData(${port},"${data}",${value})`, 1]
    };

    Blockly.C.extIot_SetIOTData = function (a) {
        Blockly.C.include.SetIOTData = '#include <SetIOTData.h>';
        let topicIndex = a.getFieldValue("TOPIC");
        let port = a.getFieldValue("SENSORPORT");
        let value = Blockly.C.valueToCode(a, "DATA", 2) || "";

        let data = ""
        if(Blockly.C.IotConfig[port]){
            let topicData = Blockly.C.IotConfig[port]
            if(topicData[topicIndex]){
                data = topicData[topicIndex]
            }
        }
        
        return `    SetIOTData(${port},"${data}",${value});\r\n`
    };
    Blockly.C.extIot_SetIOTDataStr = function (a) {
        Blockly.C.include.SetIOTDataStr = '#include <SetIOTDataStr.h>';
        let topicIndex = a.getFieldValue("TOPIC");
        let port = a.getFieldValue("SENSORPORT");
        let value = Blockly.C.valueToCode(a, "DATA", 2);

        let data = ""
        if(Blockly.C.IotConfig[port]){
            let topicData = Blockly.C.IotConfig[port]
            if(topicData[topicIndex]){
                data = topicData[topicIndex]
            }
        }
        // value = a.getInputTargetBlock("DATA") ? a.getInputTargetBlock("DATA").isShadow_ ? value : "str(" + value + ")" : ""

        
        return `    SetIOTDataStr(${port},"${data}",${value});\r\n`
    };


    // 扩展： AI

    Blockly.C.AI_sensor_setWaitForAICamData = function (a) {
        Blockly.C.include.SetWaitForAICamData = '#include <SetWaitForAICamData.h>';
        let arg1 = a.getFieldValue("DATA");
        return "    SetWaitForAICamData(" + arg1 + ",0);\r\n";
    };
    Blockly.C.AI_sensor_setAICamData = function (a) {
        Blockly.C.include.SetAICamData = '#include <SetAICamData.h>';
        let arg1 = a.getFieldValue("DATA");
        return "    SetAICamData(" + arg1 + ",0);\r\n";
    };

    Blockly.C.AI_sensor_setAICamLED = function (a) {
        Blockly.C.include.SetAICamLED = '#include <SetAICamLED.h>';
        let status = a.getFieldValue("LEDSTATUS");
        return "    SetAICamLED(" + status + ");\r\n";
    };

    Blockly.C.AI_sensor_getAICamDataColorDetect = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let arg1 = a.getFieldValue("COLOR");
        return ["GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.C.AI_sensor_getAICamDataQR = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let arg1 = a.getFieldValue("COLOR6");
        return ["GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.C.AI_sensor_getAICamDataBall = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let arg1 = a.getFieldValue("COLOR2");
        return ["GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.C.AI_sensor_getAICamDataRoad = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let arg1 = a.getFieldValue("COLOR5");
        return ["GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.C.AI_sensor_getAICamDataFaceDetect = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let arg1 = a.getFieldValue("COLOR3");
        return ["GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.C.AI_sensor_getAICamDataImage = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let arg1 = a.getFieldValue("COLOR7");
        return ["GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.C.AI_sensor_getAICamDataApriltag = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let arg1 = a.getFieldValue("COLOR7");
        return ["GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.C.AI_sensor_getAICamDataGesture = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let arg1 = a.getFieldValue("COLOR7");
        return ["GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.C.AI_sensor_getAICamDataTraffic = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let arg1 = a.getFieldValue("COLOR7");
        return ["GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.C.AI_sensor_getAICamDataColorLearning = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let arg1 = a.getFieldValue("COLOR1");
        return ["GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.C.AI_sensor_getAICamDataFaceLearning = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let arg1 = a.getFieldValue("COLOR4");
        return ["GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.C.AI_sensor_getAICamDataImageStudy = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let arg1 = a.getFieldValue("COLOR7");
        return ["GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.C.AI_sensor_getAICamData = function (a) {
        Blockly.C.include.GetAICamData = '#include <GetAICamData.h>';
        let arg1 = a.getFieldValue("DATA1");
        return ["GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.C.AI_sensor_getAICamVoice = function (a) {
        Blockly.C.include.GetAICamVoice = '#include <GetAICamVoice.h>';
        let arg1 = a.getFieldValue("ORDER");
        return ["GetAICamVoice(" + arg1 + ")", 1];
    };
    Blockly.C.AI_sensor_setFaceRegister = function (a) {
        Blockly.C.include.SetFaceRegister = '#include <SetFaceRegister.h>';
        let arg1 = Blockly.C.valueToCode(a, "ID", 1);
        return "    SetFaceRegister(" + arg1 + ");\r\n"
    };
    Blockly.C.AI_sensor_getFaceRegisterData = function (a) {
        Blockly.C.include.GetFaceRegisterData = '#include <GetFaceRegisterData.h>';
        let arg1 = Blockly.C.valueToCode(a, "ID", 1);
        return ["GetFaceRegisterData(" + arg1 + ")", 1];
    };


    Blockly.C.AI_sensor_setAICamData_setBall = function (a) {
        Blockly.C.include.SetAICamData = '#include <SetAICamData.h>';
        let ball = a.getFieldValue("BALL");
        return "    SetAICamData(4," + ball + ");\r\n";
    };
    Blockly.C.AI_sensor_setAICamData_ColorRecognition = function (a) {
        Blockly.C.include.SetAICamData = '#include <SetAICamData.h>';
        let arg = a.getFieldValue("ColorRecognitionARG");
        return "    SetAICamData(9," + arg + ");\r\n";
    };
    Blockly.C.AI_sensor_setAICamData_FaceRecognition = function (a) {
        Blockly.C.include.SetAICamData = '#include <SetAICamData.h>';
        let arg = a.getFieldValue("FaceRecognitionARG");
        return "    SetAICamData(10," + arg + ");\r\n";
    };
    Blockly.C.AI_sensor_setAICamData_imageRecognition = function (a) {
        Blockly.C.include.SetAICamData = '#include <SetAICamData.h>';
        let arg = a.getFieldValue("ImageRecognitionARG");
        return "    SetAICamData(12," + arg + ");\r\n";
    };





    // 无线扩展

    Blockly.C.extWireless_setRFPassWord = function (a) {
        Blockly.C.include.SetRFPassWord = '#include <SetRFPassWord.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.C.valueToCode(a, "DATA", 2);
        return `    SetRFPassWord(${arg1}, ${arg2});\r\n`;
    };
    Blockly.C.extWireless_setRFModuleByte = function (a) {
        Blockly.C.include.SetRFModuleByte = '#include <SetRFModuleByte.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.C.valueToCode(a, "DATA", 2);
        return `    SetRFModuleByte(${arg1}, ${arg2});\r\n`;
    };
    Blockly.C.extWireless_getRFModuleByte = function (a) {
        Blockly.C.include.GetRFModuleByte = '#include <GetRFModuleByte.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return [`GetRFModuleByte(${arg1})`, 1];
    };
    Blockly.C.extWireless_getRFModuleRemoteButton = function (a) {
        Blockly.C.include.GetRFModuleRemoteButton = '#include <GetRFModuleRemoteButton.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return [`GetRFModuleRemoteButton(${arg1})`, 1];
    };
    Blockly.C.extWireless_getRFModuleRemoteCode = function (a) {
        Blockly.C.include.GetRFModuleRemoteCode = '#include <GetRFModuleRemoteCode.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        return [`GetRFModuleRemoteCode(${arg1})`, 1];
    };
    Blockly.C.extWireless_getRFModuleRemoteGravity = function (a) {
        Blockly.C.include.GetRFModuleRemoteGravity = '#include <GetRFModuleRemoteGravity.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("AXIS");
        return [`GetRFModuleRemoteGravity(${arg1}, ${arg2})`, 1];
    };
    Blockly.C.extWireless_getRFModuleRemoteRocker = function (a) {
        Blockly.C.include.GetRFModuleRemoteRocker = '#include <GetRFModuleRemoteRocker.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("DIRECTION");
        let arg3 = a.getFieldValue("AXIS");
        return [`GetRFModuleRemoteRocker(${arg1}, ${arg2}, ${arg3})`, 1];
    };
    Blockly.C.extWireless_getRFModuleRemoteBit = function (a) {
        Blockly.C.include.GetRFModuleRemoteBit = '#include <GetRFModuleRemoteBit.h>';
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("BTN");
        return [`GetRFModuleRemoteBit(${arg1}, ${arg2})`, 1];
    };



    
    Blockly.C.extServo_SetServo = function (a, b, c) {
        Blockly.C.include.SetServo = '#include <SetServo.h>';
        let prot = a.getFieldValue("SENSORPORT_TWO");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 2);
        return "  SetServo(" + prot + "," + angle + ")\r\n";
    };

    Blockly.C.extServo_SetServoTime = function (a, b, c) {
        Blockly.C.include.SetServoTime = '#include <SetServoTime.h>';
        let prot = a.getFieldValue("SENSORPORT_TWO");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 2);
        let time = Blockly.C.valueToCode(a, "TIME", 2);
        return "  SetServoTime(" + prot + "," + angle + "," + time + ")\r\n";
    };

    Blockly.C.extServo_SetMagneticServoDegreeTime = function (a, b, c) {
        Blockly.C.include.SetMagneticServoDegreeTime = '#include <SetMagneticServoDegreeTime.h>';
        let port = a.getFieldValue("SENSORPORT");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 16);
        let time = Blockly.C.valueToCode(a, "TIME", 16);
        return `  SetMagneticServoDegreeTime(${port},${angle},${time})\r\n`;
    };

    Blockly.C.extServo_SetMagneticServoDegreeSpeed = function (a, b, c) {
        Blockly.C.include.SetMagneticServoDegreeSpeed = '#include <SetMagneticServoDegreeSpeed.h>';
        let port = a.getFieldValue("SENSORPORT");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 16);
        let speed = Blockly.C.valueToCode(a, "SPEED", 16);
        return `  SetMagneticServoDegreeSpeed(${port},${angle},${speed})\r\n`;
    };

    Blockly.C.extServo_SetMagneticServoCodeMotor = function (a, b, c) {
        Blockly.C.include.SetMagneticServoCodeMotor = '#include <SetMagneticServoCodeMotor.h>';
        let port = a.getFieldValue("SENSORPORT");
        let codenum = Blockly.C.valueToCode(a, "CODENUM", 16);
        let speed = Blockly.C.valueToCode(a, "SPEED", 16);
        return `  SetMagneticServoCodeMotor(${port},${codenum},${speed})\r\n`;
    };

    Blockly.C.extServo_SetSeeringEngine = function (a, b, c) {
        Blockly.C.include.SetSeeringEngine = '#include <SetSeeringEngine.h>';
        let port = a.getFieldValue("SENSORPORT_TWO");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 16);
        return `  SetSeeringEngine(${port},${angle})\r\n`;
    };

    Blockly.C.extServo_SetSeeringEngineTime = function (a, b, c) {
        Blockly.C.include.SetSeeringEngineTime = '#include <SetSeeringEngineTime.h>';
        let port = a.getFieldValue("SENSORPORT_TWO");
        let angle = Blockly.C.valueToCode(a, "ANGLE", 16);
        let time = Blockly.C.valueToCode(a, "TIME", 16);
        return `  SetSeeringEngineTime(${port},${angle},${time})\r\n`;
    };

    Blockly.C.extServo_SetOneServo = function (a, b, c) {
        Blockly.C.include.SetOneServo = '#include <SetOneServo.h>';
        let prop = a.getFieldValue("SENSORPORT");
        let channel = Blockly.C.valueToCode(a, "CHANNEL", 2);
        let angle = Blockly.C.valueToCode(a, "ANGLE", 2);
        let time = Blockly.C.valueToCode(a, "TIME", 2);
        return "  SetOneServo(" + prop + "," + channel + "," + angle + "," + time + ")\r\n";
    };


    //部分模块转换

    Blockly.C.text = function (a) {
        let textValue = a.getFieldValue("TEXT") || ''
        if (a.getParent().type === "extSensor_SetDisplayLattice") {
            return [`"${textValue}"`, 1]
        } else {
            if (isNaN(textValue * 1)) {
                textValue = '"' + textValue + '"'
                return [textValue, 1]
            } else {
                return [textValue, 1]
            }
        }
    }

    Blockly.C.textvalue = function (a) {
        let textValue = a.getFieldValue("TEXT") || ''
        return ['"' + textValue + '"', 1]

    }

    Blockly.C.math_integer = function (a) {
        let value = a.getFieldValue('NUM') || 'null'
        return [value, 1]
    };

    Blockly.C.math_number = function (a) {
        let value = a.getFieldValue('NUM') || 'null'
        return [value, 1]
    };
    Blockly.C.math_whole_number = function (a) {
        let value = a.getFieldValue('NUM') || 'null'
        return [value, 1]
    };

    Blockly.C.jmd_time_menu = function (a) {
        let time = a.getFieldValue('TIME') || 'null'
        return [time, 1]
    };

    Blockly.C.motor_speed_menu = function (a) {
        let value = a.getFieldValue('VALUE') || 'null'
        return [value, 1]
    };

    Blockly.C.motor_angle_menu = function (a) {
        let angle = a.getFieldValue('ANGLE') || 'null'
        return [angle, 1]
    };

    Blockly.C.motor_angle_menu_two = function (a) {
        let angle = a.getFieldValue('ANGLE') || 'null'
        return [angle, 1]
    };

    Blockly.C.motor_angle_menu_three = function (a) {
        let angle = a.getFieldValue('ANGLE') || 'null'
        return [angle, 1]
    };

    Blockly.C.show_lines_menu = function (a) {
        let lines = a.getFieldValue('LINES') || 'null'
        return [lines, 1]
    };
    Blockly.C.play_folder_menu = function (a) {
        let foldername = a.getFieldValue('FOLDERNAME') || 'null'
        return [foldername, 1]
    };

    Blockly.C.play_music_menu = function (a) {
        let musicname = a.getFieldValue('MUSICNAME') || 'null'
        return [musicname, 1]
    };

    Blockly.C.colour_picker = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };

    Blockly.C.colour_picker_Red = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };

    Blockly.C.colour_picker_Orange = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.C.colour_picker_Yellow = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.C.colour_picker_Green = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.C.colour_picker_Blue = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.C.colour_picker_Indigo = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.C.colour_picker_Purple = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.C.colour_picker_White = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };

    Blockly.C.matrix = function (a) {
        let matrix = a.getFieldValue('MATRIX') || 'null'
        return [matrix, 1]
    };

    Blockly.C.wireless_menu_key = function (a) {
        let KEY = a.getFieldValue('KEY') || 'null'
        return [KEY, 1]
    };

    Blockly.C.wireless_menu_line = function (a) {
        let LINE = a.getFieldValue('LINE') || 'null'
        return [LINE, 1]
    };



    // 变量
    Blockly.C.variables = {};
    Blockly.C.variablesHead = "VAR_";
    Blockly.C.data_variable = function (a) {
        let varible = a.workspace.getVariableById(a.getFieldValue("VARIABLE")) ? a.workspace.getVariableById(a.getFieldValue("VARIABLE")).name : ""

        varible = Blockly.C.variableDB_.getName(varible, Blockly.VARIABLE_CATEGORY_NAME)
        varible = Blockly.C.variablesHead + varible

        return [varible, Blockly.C.ORDER_ATOMIC]
    };
    Blockly.C.data_setvariableto = function (a) {
        let varible = a.workspace.getVariableById(a.getFieldValue("VARIABLE")) ? a.workspace.getVariableById(a.getFieldValue("VARIABLE")).name : ""
        let num = Blockly.C.valueToCode(a, "VALUE", 2)

        varible = Blockly.C.variableDB_.getName(varible, Blockly.VARIABLE_CATEGORY_NAME)
        varible = Blockly.C.variablesHead + varible

        return `    ${varible} = ${num};\r\n`
    };
    Blockly.C.data_changevariableby = function (a) {
        let varible = a.workspace.getVariableById(a.getFieldValue("VARIABLE")) ? a.workspace.getVariableById(a.getFieldValue("VARIABLE")).name : ""
        let num = Blockly.C.valueToCode(a, "VALUE", 2)

        varible = Blockly.C.variableDB_.getName(varible, Blockly.VARIABLE_CATEGORY_NAME)
        varible = Blockly.C.variablesHead + varible

        return `    ${varible} += ${num};\r\n`
    };




    //   列表
    Blockly.C.data_listHead = "list_"
    Blockly.C.data_listcontents = function (a) {
        Blockly.C.include.include_list = '#include <jmdlist.h>';

        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';

        listname = Blockly.C.variableDB_.getName(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.Names.prototype.safeName_(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.C.data_listHead + listname

        return [listname, 1]
    };
    Blockly.C.data_addtolist = function (a) {
        Blockly.C.include.include_list = '#include <jmdlist.h>';
        let str = Blockly.C.valueToCode(a, "ITEM", 2)
        if (
            a.getInputTargetBlock("ITEM") &&
            (a.getInputTargetBlock("ITEM").type == "data_variable" ||
                a.getInputTargetBlock("ITEM").type == "argument_reporter_string_number")
        ) {
            str = `&${str}`
        }


        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';

        listname = Blockly.C.variableDB_.getName(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.Names.prototype.safeName_(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.C.data_listHead + listname

        return `    ${listname}.Append(${listname}.data, ${str});\r\n`
    };

    Blockly.C.data_deleteoflist = function (a) {
        Blockly.C.include.include_list = '#include <jmdlist.h>';
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';

        listname = Blockly.C.variableDB_.getName(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.Names.prototype.safeName_(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.C.data_listHead + listname

        let line = Blockly.C.valueToCode(a, "INDEX", 2)

        if (isNaN(Number(line))) {
            let str = line.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                line = line + " - 1"
            } else {
                line = Number(line) > 0 ? Number(line) - 1 : 0;
            }
        } else {
            line = Number(line) > 0 ? Number(line) - 1 : 0;
        }
        return `    ${listname}.Delete_One(${listname}.data, ${line});\r\n`
    };

    Blockly.C.data_deletealloflist = function (a) {
        Blockly.C.include.include_list = '#include <jmdlist.h>';
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';

        listname = Blockly.C.variableDB_.getName(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.Names.prototype.safeName_(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.C.data_listHead + listname

        return `    ${listname}.Delete_All(${listname}.data);\r\n`
    };

    Blockly.C.data_insertatlist = function (a) {
        Blockly.C.include.include_list = '#include <jmdlist.h>';
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';

        listname = Blockly.C.variableDB_.getName(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.Names.prototype.safeName_(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.C.data_listHead + listname

        let index = Blockly.C.valueToCode(a, "INDEX", 2)

        if (isNaN(Number(index))) {
            let str = index.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                index = index + " - 1"
            } else {
                index = Number(index) > 0 ? Number(index) - 1 : 0;
            }
        } else {
            index = Number(index) > 0 ? Number(index) - 1 : 0;
        }

        let item = Blockly.C.valueToCode(a, "ITEM", 2)
        if (
            a.getInputTargetBlock("ITEM") &&
            (a.getInputTargetBlock("ITEM").type == "data_variable" ||
                a.getInputTargetBlock("ITEM").type == "argument_reporter_string_number")
        ) {
            item = `&${item}`
        }

        return `    ${listname}.Insert(${listname}.data,${index}, ${item});\r\n`
    };
    Blockly.C.data_replaceitemoflist = function (a) {
        Blockly.C.include.include_list = '#include <jmdlist.h>';
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';

        listname = Blockly.C.variableDB_.getName(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.Names.prototype.safeName_(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.C.data_listHead + listname

        let index = Blockly.C.valueToCode(a, "INDEX", 2)
        if (isNaN(Number(index))) {
            let str = index.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                index = index + " - 1"
            } else {
                index = Number(index) > 0 ? Number(index) - 1 : 0;
            }
        } else {
            index = Number(index) > 0 ? Number(index) - 1 : 0;
        }

        let item = Blockly.C.valueToCode(a, "ITEM", 2)
        if (
            a.getInputTargetBlock("ITEM") &&
            (a.getInputTargetBlock("ITEM").type == "data_variable" ||
                a.getInputTargetBlock("ITEM").type == "argument_reporter_string_number")
        ) {
            item = `&${item}`
        }
        return `    ${listname}.Replace(${listname}.data, ${index}, ${item});\r\n`
    };

    Blockly.C.data_listcontainsitem = function (a) {
        Blockly.C.include.include_list = '#include <jmdlist.h>';
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';

        listname = Blockly.C.variableDB_.getName(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.Names.prototype.safeName_(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.C.data_listHead + listname

        let str = Blockly.C.valueToCode(a, "ITEM", 2)
        if (
            a.getInputTargetBlock("ITEM") &&
            (a.getInputTargetBlock("ITEM").type == "data_variable" ||
                a.getInputTargetBlock("ITEM").type == "argument_reporter_string_number")
        ) {
            str = `&${str}`
        }
        return [`${listname}.Include_Data(${listname}.data, ${str})`, 1]
    };

    Blockly.C.data_itemnumoflist = function (a) {

        Blockly.C.include.include_list = '#include <jmdlist.h>';
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';

        listname = Blockly.C.variableDB_.getName(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.Names.prototype.safeName_(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.C.data_listHead + listname

        let str = Blockly.C.valueToCode(a, "ITEM", 2)
        if (
            a.getInputTargetBlock("ITEM") &&
            (a.getInputTargetBlock("ITEM").type == "data_variable" ||
                a.getInputTargetBlock("ITEM").type == "argument_reporter_string_number")
        ) {
            str = `&${str}`
        }
        return [`${listname}.Find_Num(${listname}.data, ${str})`, 1]
    };

    Blockly.C.data_itemoflist = function (a) {
        Blockly.C.include.include_list = '#include <jmdlist.h>';
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';

        listname = Blockly.C.variableDB_.getName(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.Names.prototype.safeName_(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.C.data_listHead + listname

        let num = Blockly.C.valueToCode(a, "INDEX", 2)

        if (isNaN(Number(num))) {
            let str = num.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                num = num + " - 1"
            } else {
                num = Number(num) > 0 ? Number(num) - 1 : 0;
            }
        } else {
            num = Number(num) > 0 ? Number(num) - 1 : 0;
        }
        return [`(*${listname}.Find_Data(${listname}.data, ${num}))`, 1]
    };
    Blockly.C.data_lengthoflist = function (a) {
        Blockly.C.include.include_list = '#include <jmdlist.h>';

        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';

        listname = Blockly.C.variableDB_.getName(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.Names.prototype.safeName_(listname, Blockly.VARIABLE_CATEGORY_NAME)
        listname = Blockly.C.data_listHead + listname

        return [`${listname}.Find_Node(${listname}.data)`, 1]
    };




    //运算
    Blockly.C.operator_add = function (a) {
        let NUM1 = Blockly.C.valueToCode(a, "NUM1", 2) || 1
        let NUM2 = Blockly.C.valueToCode(a, "NUM2", 2) || 1
        return [`${NUM1} + ${NUM2}`, 2]
    };
    Blockly.C.operator_subtract = function (a) {
        let NUM1 = Blockly.C.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.C.valueToCode(a, "NUM2", 2)
        return [`${NUM1} - ${NUM2}`, 2]
    };
    Blockly.C.operator_multiply = function (a) {
        let NUM1 = Blockly.C.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.C.valueToCode(a, "NUM2", 2)
        return [`${NUM1} * ${NUM2}`, 2]
    };
    Blockly.C.operator_divide = function (a) {
        let NUM1 = Blockly.C.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.C.valueToCode(a, "NUM2", 2)
        return [`${NUM1} / ${NUM2}`, 2]
    };
    Blockly.C.operator_random = function (a) {
        Blockly.C.include.GetRandom = '#include <GetRandom.h>';
        let RANDOMSTART = Blockly.C.valueToCode(a, "FROM", 2)
        let RANDOMEND = Blockly.C.valueToCode(a, "TO", 2)
        RANDOMEND = isNaN(Number(RANDOMEND)) ? RANDOMEND : Number(RANDOMEND)
        return [`GetRandom(${RANDOMSTART},${RANDOMEND})`, 1]
    };
    Blockly.C.operator_lt = function (a) {
        let OPERAND1 = Blockly.C.valueToCode(a, "OPERAND1", 2)
        let OPERAND2 = Blockly.C.valueToCode(a, "OPERAND2", 2)
        return [`${OPERAND1} < ${OPERAND2}`, 2]
    };
    Blockly.C.operator_equals = function (a) {
        let OPERAND1 = Blockly.C.valueToCode(a, "OPERAND1", 2)
        let OPERAND2 = Blockly.C.valueToCode(a, "OPERAND2", 2)
        return [`${OPERAND1} == ${OPERAND2}`, 2]
    };
    Blockly.C.operator_gt = function (a) {
        let OPERAND1 = Blockly.C.valueToCode(a, "OPERAND1", 2)
        let OPERAND2 = Blockly.C.valueToCode(a, "OPERAND2", 2)
        return [`${OPERAND1} > ${OPERAND2}`, 2]
    };
    Blockly.C.operator_and = function (a) {
        let OPERAND1 = Blockly.C.valueToCode(a, "OPERAND1", 2) || "()"
        let OPERAND2 = Blockly.C.valueToCode(a, "OPERAND2", 2) || "()"
        return [`${OPERAND1} && ${OPERAND2}`, 2]
    };
    Blockly.C.operator_or = function (a) {
        let OPERAND1 = Blockly.C.valueToCode(a, "OPERAND1", 2) || "()"
        let OPERAND2 = Blockly.C.valueToCode(a, "OPERAND2", 2) || "()"
        return [`${OPERAND1} || ${OPERAND2}`, 2]
    };
    Blockly.C.operator_not = function (a) {
        let OPERAND = Blockly.C.valueToCode(a, "OPERAND", 1)
        return [`!(${OPERAND})`, 1]
    };
    Blockly.C.operator_mod = function (a) {
        let NUM1 = Blockly.C.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.C.valueToCode(a, "NUM2", 2)
        return [`((int)${NUM1}) % ((int)${NUM2})`, 1]
    };
    Blockly.C.operator_round = function (a) {
        let NUM = Blockly.C.valueToCode(a, "NUM", 2)
        return [`((int)(${NUM} + 0.5)>(int)${NUM}?(int)(${NUM} + 1):(int)${NUM})`, 1]
    };
    Blockly.C.operator_mathop = function (a) {
        Blockly.C.include.stdio = '#include <stdio.h>';
        Blockly.C.include.math = '#include <math.h>';

        let OPERATOR = a.getFieldValue("OPERATOR")
        let NUM = Blockly.C.valueToCode(a, "NUM", 2)
        NUM = NUM == 'null' ? '' : NUM

        let str = ''

        if (OPERATOR == "abs") {
            str = "fabs(" + NUM + ")";
        } else if (OPERATOR == "floor") {
            str = "floor(" + NUM + ")";
        } else if (OPERATOR == "ceil") {
            str = "ceil(" + NUM + ")";
        } else if (OPERATOR == "sqrt") {
            str = "sqrt(" + NUM + ")";
        } else if (OPERATOR == "sin") {
            str = "sin(" + NUM + ")";
        } else if (OPERATOR == "cos") {
            str = "cos(" + NUM + ")";
        } else if (OPERATOR == "tan") {
            str = "tan(" + NUM + ")";
        } else if (OPERATOR == "asin") {
            str = "asin(" + NUM + ")";
        } else if (OPERATOR == "acos") {
            str = "acos(" + NUM + ")";
        } else if (OPERATOR == "atan") {
            str = "atan(" + NUM + ")";
        } else if (OPERATOR == "log") {
            str = "log(" + NUM + ")";
        } else if (OPERATOR == "log10") {
            str = "log10(" + NUM + ")";
        } else if (OPERATOR == "e ^") {
            str = "exp(" + NUM + ")";
        } else if (OPERATOR == "10 ^") {
            str = "pow(10," + NUM + ")";
        }
        return [str, 1]
    };

    Blockly.C.operator_join = function (a) {

        Blockly.C.include.stdio = '#include <stdio.h>';
        Blockly.C.include.string = '#include <string.h>';
        let string1 = Blockly.C.valueToCode(a, "STRING1", 2)
        string1 = Blockly.C.removeStar(a, "STRING1", string1)

        let string2 = Blockly.C.valueToCode(a, "STRING2", 2)
        string2 = Blockly.C.removeStar(a, "STRING2", string2)
        return [`strcon(${string1},${string2})`, 1]
    };

    Blockly.C.operator_letter_of = function (a) {
        let letter = Blockly.C.valueToCode(a, "LETTER", 2)
        let string = Blockly.C.valueToCode(a, "STRING", 2)
        string = Blockly.C.removeStar(a, "STRING", string)
        return [`strpos(${string},${letter})`, 1]
    };

    Blockly.C.operator_length = function (a) {
        let string = Blockly.C.valueToCode(a, "STRING", 2)
        string = Blockly.C.removeStar(a, "STRING", string)
        return [`strlen(${string})`, 1]
    };

    Blockly.C.operator_contains = function (a) {
        let string1 = Blockly.C.valueToCode(a, "STRING1", 2)
        string1 = Blockly.C.removeStar(a, "STRING1", string1)

        let string2 = Blockly.C.valueToCode(a, "STRING2", 2)
        string2 = Blockly.C.removeStar(a, "STRING2", string2)
        return [`strcom(${string1},${string2})`, 1]
    };
    
    Blockly.C.operator_strToNum = function (a) {
        Blockly.C.include.jmdstoi = '#include "jmdstoi.h"';
        Blockly.C.include.stdio = '#include <stdio.h>';
        Blockly.C.include.stdlib = '#include <stdlib.h>';
        
        let string = Blockly.C.valueToCode(a, "STRING", 3) || ""
        return [`atoi(${string})`, 1]
    };
    Blockly.C.operator_numToStr = function (a) {
        Blockly.C.include.jmdstoi = '#include "jmdstoi.h"';
        Blockly.C.include.stdio = '#include <stdio.h>';
        Blockly.C.include.stdlib = '#include <stdlib.h>';
        let num = Blockly.C.valueToCode(a, "NUM", 3) || ""
        return [`inttostr(${num})`, 1]
    };





    // 自制积木

    // %s 数字类型控件 argument_reporter_string_number
    // %d 布尔类型控件 argument_reporter_boolean


    Blockly.C.procedures_definition = function (a) {
        let b = Blockly.C.blockToCode(a.workspace.getBlockById(a.getChildren(a)[0].id))
        Blockly.C.FnList[b] = `void ${b};`
        return `void ${b}\r\n{\n`;
    };
    Blockly.C.procedures_prototype = function (a) {
        // console.log('procedures_prototype', a)
        let fnName = a.getProcCode().replace(/%[sbn\s]|\s/ig, '').trim()
        fnName = Blockly.C.variableDB_.getName(fnName, Blockly.VARIABLE_CATEGORY_NAME)

        let children = a.getChildren(a)
        let array = []
        for (let i = 0; i < children.length; i++) {
            if (a.workspace.getBlockById(children[i].id)) {
                let value = Blockly.C.blockToCode(a.workspace.getBlockById(children[i].id))
                let type = children[i].type
                if (type == "argument_reporter_boolean") {
                    // array.push("boolean " + value[0])
                    array.push("int " + Blockly.Names.prototype.safeName_(value[0], Blockly.VARIABLE_CATEGORY_NAME))
                }
                if (type == "argument_reporter_string_number") {
                    array.push("double " + Blockly.Names.prototype.safeName_(value[0], Blockly.VARIABLE_CATEGORY_NAME))
                }
            }
        }
        fnName += `(${array.join(',')})`

        return fnName;
    };
    Blockly.C.argument_reporter_boolean = function (a) {
        let text = a.inputList[0].fieldRow[0].getText()
        text = Blockly.Names.prototype.safeName_(text, Blockly.VARIABLE_CATEGORY_NAME)
        return [text, 1];
    };
    Blockly.C.argument_reporter_string_number = function (a) {
        let text = a.inputList[0].fieldRow[0].getText()
        text = Blockly.Names.prototype.safeName_(text, Blockly.VARIABLE_CATEGORY_NAME)

        return [text, 1];
    };

    Blockly.C.procedures_call = function (a) {
        // console.log('procedures_call', a)

        let array = []
        let fnName = a.getProcCode().replace(/(%s|%b|%n)|\s/ig, '')
        fnName = Blockly.C.variableDB_.getName(fnName, Blockly.VARIABLE_CATEGORY_NAME)

        for (let i = 0; i < a.inputList.length; i++) {
            if (a.inputList[i].name !== '') {
                let blocks = a.inputList[i].connection.targetBlock()
                if (blocks) {
                    let child = Blockly.C.blockToCode(a.workspace.getBlockById(blocks.id))
                    if (Array.isArray(child)) {
                        var arg = child[0]
                        if (child[1] === 2 || child[1] === 99) {
                            arg = '(' + arg + ')'
                        }
                        if (!(/[^\s]/ig.test(child[0]))) { //判断是否为数字或字符串
                            if (child[0] == "") { //判断字符串是否为空
                                array.push(arg)
                            } else {
                                array.push('"' + arg + '"')
                            }
                        } else {
                            array.push(arg)
                        }
                    } else {
                        array.push(child)
                    }
                } else {
                    array.push('"false"')
                }
            }
        }

        fnName += `(${array.join(',')})`

        return `    ${fnName};\r\n`;
    };


}

export {
    toC_C6
}
